const CAD_APPEARANCE = {"solo":{"levers":["NAUO37_0","NAUO38_0","NAUO39_0","NAUO40_0"],"paintedFrames":["NAUO4_0","NAUO4_1","NAUO4_2","NAUO4_3","NAUO35_0","NAUO12_0","NAUO31_0"],"fans":["NAUO21_0"],"lightHousings":["NAUO29_0"],"ceilingFelt":[]},"solo-plus":{"levers":["NAUO47_0","NAUO48_0","NAUO49_0","NAUO50_0"],"paintedFrames":["NAUO4_0","NAUO4_1","NAUO4_2","NAUO4_4","NAUO45_0","NAUO19_0","NAUO20_0","NAUO21_0","NAUO38_0","NAUO39_0"],"fans":["NAUO26_0"],"lightHousings":["NAUO27_0"],"ceilingFelt":[]},"duo":{"levers":["NAUO47_0","NAUO48_0","NAUO49_0","NAUO50_0"],"paintedFrames":["NAUO4_0","NAUO4_1","NAUO4_2","NAUO4_4","NAUO45_0","NAUO19_0","NAUO20_0","NAUO21_0","NAUO38_0","NAUO39_0"],"fans":["NAUO26_0"],"lightHousings":["NAUO27_0"],"ceilingFelt":[]},"team":{"levers":["NAUO48_0","NAUO49_0","NAUO50_0","NAUO51_0"],"paintedFrames":["NAUO4_0","NAUO4_1","NAUO4_2","NAUO4_3","NAUO46_0","NAUO17_0","NAUO18_1","NAUO31_1","NAUO32_1","NAUO33_1","NAUO38_0","NAUO42_0","NAUO43_0"],"fans":["NAUO23_0"],"lightHousings":["NAUO24_0","NAUO39_0"],"ceilingFelt":["NAUO12_0","NAUO12_1"]},"meet":{"levers":["NAUO53_0","NAUO54_0","NAUO55_0","NAUO56_0"],"paintedFrames":["NAUO48_0","NAUO52_0","NAUO52_1","NAUO52_3","NAUO52_4","NAUO16_0","NAUO17_0","NAUO27_0","NAUO28_0","NAUO29_0","NAUO39_0","NAUO40_0","NAUO41_0"],"fans":["NAUO22_0","NAUO32_0"],"lightHousings":["NAUO33_0","NAUO34_0"],"ceilingFelt":["NAUO11_0","NAUO11_1"]},"max":{"levers":["NAUO58_0","NAUO59_0","NAUO60_0","NAUO61_0"],"paintedFrames":["NAUO56_0","NAUO16_0","NAUO17_0","NAUO29_0","NAUO30_0","NAUO31_0","NAUO49_0","NAUO50_0","NAUO51_0","NAUO54_0","NAUO54_1","NAUO54_3","NAUO54_4"],"fans":["NAUO22_0","NAUO40_0","NAUO53_0"],"lightHousings":["NAUO43_4","NAUO44_4"],"ceilingFelt":[]}};
// viewer.js — FocusPod 3D Viewer

const MODEL_FILES = {
  'solo':      'https://cdn.shopify.com/3d/models/61822aca0e153fb1/solo.glb',
  'solo-plus': 'https://cdn.shopify.com/3d/models/6a84a2bd21aa5b5c/duo2.glb',
  'duo':       'https://cdn.shopify.com/3d/models/6a84a2bd21aa5b5c/duo2.glb',
  'team':      'https://cdn.shopify.com/3d/models/fa95ed9c422082ab/Team_GIB.glb',
  'meet':      'https://cdn.shopify.com/3d/models/c73cda7cf3863bae/Meet.glb',
  'max':       'https://cdn.shopify.com/3d/models/48e114af22f5548b/max2.glb',
};
if (window.FocusPodReplacement) Object.assign(MODEL_FILES, window.FocusPodReplacement.modelFiles);


let scene, camera, renderer, controls, currentModel;
let addonParents    = {};
let currentAddonKey = 'Addon1';
let currentExteriorHex = '#f0f0ee';
let currentInteriorHex = '#8a8a8a';
let currentSeatHex     = '#8a8a8a';
let exteriorMats = [], interiorMats = [], seatMats = [], glassMats = [], glassFrontMats = [], glassRearMats = [];
let airconNode = null;
let airconNodes = [], ventilationNodes = [], climateModelKey = 'solo';
let glassNodes = [], pdlcVersion = 0;
let viewerTourReady = false;
let viewerTour = null;
let viewerContactShadow = null;
let viewerTourAnchorHidden = false;
let viewerTourAnchor = { active: false, key: 'exterior', index: 0, furnitureKey: '', visible: false, x: .5, y: .5, distance: null };
const tourProjectedAnchor = new THREE.Vector3();
const tourAnchoredStages = new Set(['roof_vents', 'wheels', 'magnetic_close', 'occupancy', 'rear_glass', 'power', 'control_panel', 'lighting', 'ventilation', 'furniture', 'furniture_detail']);
const TOUR_ORIGINAL_PARTS = {"solo":{"cut":[null,null],"hinge":[0.482995,0.506983],"occupancy":[0.49398,2.265847,0.491299]},"solo-plus":{"cut":[0.02325,null],"hinge":[0.816438,0.454318],"occupancy":[0.827113,2.253653,0.43881]},"duo":{"cut":[0.02325,null],"hinge":[0.816438,0.454318],"occupancy":[0.827113,2.253653,0.43881]},"team":{"cut":[-0.397975,0.397975],"hinge":[0.392995,0.490034],"occupancy":[1.104006,2.253585,0.469215]},"meet":{"cut":[-0.39871,0.402897],"hinge":[0.393006,0.894448],"occupancy":[1.104077,2.253907,0.878627]},"max":{"cut":[-0.397995,0.397995],"hinge":[0.393019,1.309501],"occupancy":[1.253748,2.253785,1.293831]}};
const TOUR_ORIGINAL_FEATURES = {"solo":{"wheel":[0.482924,0.03981,0.350001],"vent":[0.330506,2.247975,-7e-06]},"solo-plus":{"wheel":[0.814191,0.030051,0.259617],"vent":[-0.432091,2.239941,-0.65016]},"duo":{"wheel":[0.814191,0.030051,0.259617],"vent":[-0.432091,2.239941,-0.65016]},"team":{"wheel":[1.092914,0.039809,0.339856],"vent":[-0.855509,2.239993,-0.205012]},"meet":{"wheel":[1.094078,0.039815,0.701204],"vent":[0.855509,2.240132,0.615023]},"max":{"wheel":[1.242768,0.039836,1.150078],"vent":[1.005522,2.240053,1.025023]}};

const TOUR_CEILING_VENTS = {"solo":{"min":[0.305511,2.237973,-0.095019],"max":[0.355501,2.257978,0.095005],"center":[0.330506,2.247975,-7e-06]},"solo-plus":{"min":[-0.457089,2.229968,-0.745167],"max":[-0.407093,2.249915,-0.555154],"center":[-0.432091,2.239941,-0.65016]},"duo":{"min":[-0.457089,2.229968,-0.745167],"max":[-0.407093,2.249915,-0.555154],"center":[-0.432091,2.239941,-0.65016]},"team":{"min":[-0.8805,2.229997,-0.300033],"max":[-0.830517,2.24999,-0.109991],"center":[-0.855509,2.239993,-0.205012]},"meet":{"min":[0.830517,2.230135,-0.71],"max":[0.8805,2.250128,-0.519959],"center":[0.855509,2.240132,-0.614979]},"max":{"min":[0.980489,2.230011,-1.229126],"max":[1.030555,2.250095,-1.039188],"center":[1.005522,2.240053,-1.134157]}};

function tourStatus() {
  return { active: Boolean(viewerTour), status: viewerTour?.status || 'idle', index: viewerTour?.index || 0,
    count: viewerTour?.segments.length || 0, key: viewerTour?.segments[viewerTour.index]?.key || 'exterior',
    ready: Boolean(currentModel && viewerTourReady), mode: viewerTour?.mode || 'full', furnitureKey: viewerTour?.furnitureKey || '', occupancyState: viewerTour?.occupancyState || '' };
}
function tourAnchor() { return { ...viewerTourAnchor }; }
function updateTourAnchor(force = false) {
  if (!viewerTour && !viewerTourAnchor.active && !force) return;
  const segment = viewerTour?.segments[viewerTour.index];
  const next = { active: Boolean(viewerTour), key: segment?.key || 'exterior', index: viewerTour?.index || 0,
    furnitureKey: viewerTour?.furnitureKey || '', occupancyState: viewerTour?.occupancyState || '', visible: false, x: .5, y: .5, distance: null };
  const anchorReady = segment && !viewerTour?.move && (viewerTour.elapsed >= segment.travelDuration || (segment.furnitureKey && viewerTour.segments[viewerTour.index - 1]?.furnitureKey));
  if (segment?.anchor && anchorReady && camera && !viewerTourAnchorHidden && !document.hidden) {
    camera.updateMatrixWorld();
    tourProjectedAnchor.copy(segment.anchor);
    if (segment.key === 'magnetic_close' && viewerTour.door) { const pivot=viewerTour.door.pivot,angle=viewerTour.door.group.rotation.y,x=tourProjectedAnchor.x-pivot.x,z=tourProjectedAnchor.z-pivot.z; tourProjectedAnchor.x=pivot.x+x*Math.cos(angle)+z*Math.sin(angle);tourProjectedAnchor.z=pivot.z-x*Math.sin(angle)+z*Math.cos(angle); }
    const distance=Math.sqrt(camera.position.distanceToSquared(tourProjectedAnchor));tourProjectedAnchor.project(camera);
    const { x, y, z } = tourProjectedAnchor;
    const finite = Number.isFinite(x) && Number.isFinite(y) && Number.isFinite(z);
    next.visible = finite && x >= -1 && x <= 1 && y >= -1 && y <= 1 && z >= -1 && z <= 1;
    if (finite) { next.x = (x + 1) / 2; next.y = (1 - y) / 2; }
    next.distance = distance;
  }
  const before = viewerTourAnchor;
  const changed = force || next.active !== before.active || next.key !== before.key || next.index !== before.index || next.furnitureKey !== before.furnitureKey || next.occupancyState !== before.occupancyState || next.visible !== before.visible
    || (next.visible && (Math.abs(next.x - before.x) >= .002 || Math.abs(next.y - before.y) >= .002 || Math.abs(next.distance - before.distance) >= .025));
  if (!changed) return;
  viewerTourAnchor = next;
  window.dispatchEvent(new CustomEvent('fp:tour-anchor', { detail: tourAnchor() }));
}
function emitTourState() { window.dispatchEvent(new CustomEvent('fp:tour-state', { detail: tourStatus() })); updateTourAnchor(true); }
function tourVisible(node) {
  for (let parent = node; parent; parent = parent.parent) { if (parent.visible === false && !viewerTour?.hiddenOriginals?.get(parent)) return false; if (parent === currentModel) return true; }
  return false;
}
function tourMeshBounds(nodes, includeHidden = false) {
  const box = new THREE.Box3();
  nodes.forEach(node => {
    if (!node.isMesh || !node.geometry || (!includeHidden && !tourVisible(node))) return;
    if (!node.geometry.boundingBox) node.geometry.computeBoundingBox();
    if (node.geometry.boundingBox) box.union(node.geometry.boundingBox.clone().applyMatrix4(node.matrixWorld));
  });
  return box;
}
function tourAddonBounds(key) {
  return tourMeshBounds((addonParents[key] || []).filter(node => !/arm_screen|roizet|rozet|roz[eio]?tk|ramka|pilaster|_fw|^Addon\d+$|glass/i.test(node.name)), true);
}
function tourRepresentativeAnchor(nodes, preferred, includeHidden = false) {
  const result = preferred.clone(), candidate = new THREE.Vector3(); let closest = Infinity;
  nodes.forEach(node => {
    if (!includeHidden && !tourVisible(node)) return;
    const position = node.geometry?.attributes?.position, index = node.geometry?.index;
    if (!position) return;
    const count = index ? index.count : position.count, stride = Math.max(1, Math.ceil(count / 600)) * 3;
    for (let i = 0; i + 2 < count; i += stride) {
      const a = index ? index.getX(i) : i, b = index ? index.getX(i + 1) : i + 1, c = index ? index.getX(i + 2) : i + 2;
      candidate.set((position.getX(a)+position.getX(b)+position.getX(c))/3,(position.getY(a)+position.getY(b)+position.getY(c))/3,(position.getZ(a)+position.getZ(b)+position.getZ(c))/3).applyMatrix4(node.matrixWorld);
      const distance = candidate.distanceToSquared(preferred); if (distance < closest) { closest = distance; result.copy(candidate); }
    }
  });
  return result;
}
function tourGeometry() {
  currentModel.updateMatrixWorld(true);
  const furniture = new Set(Object.values(addonParents).flat()), climate = new Set(airconNodes), shell = [], all = [];
  currentModel.traverse(node => { if (!node.isMesh || node.userData.focusPodSticker) return; all.push(node); if (!furniture.has(node) && !climate.has(node)) shell.push(node); });
  const box = tourMeshBounds(shell);
  if (box.isEmpty()) return null;
  const center = box.getCenter(new THREE.Vector3()), size = box.getSize(new THREE.Vector3());
  if (![size.x, size.y, size.z].every(value => Number.isFinite(value) && value > 0)) return null;
  const bounds = pattern => tourMeshBounds(all.filter(node => pattern.test(node.name)));
  const features = { door: bounds(/^Exterior_ramka$/i), handle: bounds(/^Exterior_ruc[hck]+a$/i),
    roof: bounds(/(?:Interior|Inretior)_Roof$/i), roofVents: bounds(/v?ventel|ventilation/i),
    power: bounds(/roizet|rozet|roz[eio]?tk/i), control: bounds(/touch[ _]?cont|knopka/i), occupancy: bounds(/exterior_green[ _]?light/i), rearGlass: bounds(/^Interior_Glass[._]?001$/i), light: bounds(/white.?light|rwhite.?light|_lampi$/i), floor: bounds(/(?:^|_)floor$/i) };
  if (viewerTour?.furnitureKeys.length) {
    const initialFurniture = new Set(addonParents[viewerTour.furnitureKeys[0]] || []);
    features.power = tourMeshBounds(all.filter(node => /roizet|rozet|roz[eio]?tk/i.test(node.name) && (!furniture.has(node) || initialFurniture.has(node))), true);
  }
  const halfVertical = camera.fov * Math.PI / 360, halfHorizontal = Math.atan(Math.tan(halfVertical) * camera.aspect);
  const distance = box.getBoundingSphere(new THREE.Sphere()).radius / Math.sin(Math.min(halfVertical, halfHorizontal)) * 1.14;
  const point = (x, y, z) => new THREE.Vector3(box.min.x + size.x * x, box.min.y + size.y * y, box.min.z + size.z * z);
  const door = features.door.isEmpty() ? center.clone() : features.door.getCenter(new THREE.Vector3());
  const eye = box.min.y + size.y * .77;
  const detail = TOUR_ORIGINAL_FEATURES[climateModelKey] || {};
  const anchors = {};
  if (!features.light.isEmpty()) {
    const lightNodes=all.filter(node=>/white.?light|rwhite.?light|_lampi$/i.test(node.name)),vent=TOUR_CEILING_VENTS[climateModelKey],lightCenter=features.light.getCenter(new THREE.Vector3()),region=new THREE.Box3(),vertex=new THREE.Vector3();
    if(vent&&features.light.max.x-features.light.min.x>.15)lightNodes.forEach(node=>{const positions=node.geometry?.attributes?.position;if(!positions)return;for(let i=0;i<positions.count;i++){vertex.fromBufferAttribute(positions,i).applyMatrix4(node.matrixWorld);if((vertex.x-lightCenter.x)*(vent.center[0]-lightCenter.x)>0)region.expandByPoint(vertex);}});
    features.lightPair=region.isEmpty()?features.light:region;anchors.light=tourRepresentativeAnchor(lightNodes,features.lightPair.getCenter(new THREE.Vector3()));
  }
  if (!features.roofVents.isEmpty()) anchors.roofVents = tourRepresentativeAnchor(all.filter(node => /v?ventel|ventilation/i.test(node.name)), features.roofVents.getCenter(new THREE.Vector3()));
  return { box, center, size, distance, features, anchors, point, detail, near: .018,
    doorOutside: new THREE.Vector3(door.x, eye, box.max.z + .32),
    doorInside: new THREE.Vector3(door.x, eye, box.max.z - .15),
    inside: new THREE.Vector3(center.x, eye, box.max.z - Math.min(.24, size.z * .18)),
    insideTarget: point(.5, .36, .18) };
}
function tourCopyPose(pose) { return { position: pose.position.clone(), target: pose.target.clone(), near: pose.near }; }
function tourCurrentPose() { return { position: camera.position.clone(), target: controls.target.clone(), near: camera.near }; }
function tourPoint(position, target, near = .018) { return { position: position.clone(), target: target.clone(), near }; }
function tourIsInside(position, g = viewerTour.geometry) {
  return position.x > g.box.min.x && position.x < g.box.max.x && position.y > g.box.min.y && position.y < g.box.max.y && position.z > g.box.min.z && position.z < g.box.max.z;
}
function tourSafePath(from, to) {
  const g = viewerTour.geometry, points = [tourCopyPose(from)], fromInside = tourIsInside(from.position), toInside = tourIsInside(to.position);
  if (fromInside && !toInside) {
    points.push(tourPoint(g.doorInside, g.insideTarget), tourPoint(g.doorOutside, g.insideTarget));
    points.push(...tourSafePath(points[points.length - 1], to).slice(1, -1));
  } else if (!fromInside && toInside) {
    const approach = new THREE.Vector3(g.doorOutside.x, g.doorOutside.y, g.box.max.z + Math.max(.65, g.size.z * .45));
    const arrival = tourPoint(approach, g.insideTarget);
    points.push(...tourSafePath(from, arrival).slice(1), tourPoint(g.doorOutside, g.insideTarget), tourPoint(g.doorInside, g.insideTarget));
  } else if (!fromInside && !toInside) {
    const a = from.position, b = to.position;
    if (a.z < g.box.max.z || b.z < g.box.max.z) {
      const radius = Math.max(g.distance, Math.hypot(a.x - g.center.x, a.z - g.center.z), Math.hypot(b.x - g.center.x, b.z - g.center.z));
      let first = Math.atan2(a.x - g.center.x, a.z - g.center.z), last = Math.atan2(b.x - g.center.x, b.z - g.center.z);
      while (last - first > Math.PI) last -= Math.PI * 2;
      while (last - first < -Math.PI) last += Math.PI * 2;
      const count = Math.max(1, Math.ceil(Math.abs(last - first) / .45));
      for (let i = 0; i <= count; i++) {
        const t = i / count, angle = first + (last - first) * t;
        points.push(tourPoint(new THREE.Vector3(g.center.x + Math.sin(angle) * radius, a.y + (b.y - a.y) * t, g.center.z + Math.cos(angle) * radius), g.center));
      }
    }
  }
  points.push(tourCopyPose(to));
  return points;
}
function tourSample(points, progress, output) {
  const p = Math.max(0, Math.min(1, progress));
  const scaled = p * (points.length - 1), index = Math.min(points.length - 2, Math.floor(scaled));
  const amount = scaled - index, eased = amount * amount * (3 - 2 * amount), a = points[index], b = points[index + 1];
  output.position.copy(a.position).lerp(b.position, eased); output.target.copy(a.target).lerp(b.target, eased);
  output.near = Math.min(a.near, b.near); return output;
}
function tourSegmentPose(segment, elapsed, output) {
  if (elapsed <= segment.travelDuration || !segment.holdDuration) return tourSample(segment.points,Math.min(1,elapsed/segment.travelDuration),output);
  const progress = Math.min(1,(elapsed-segment.travelDuration)/segment.holdDuration), amount = progress*progress*(3-2*progress), arrival = segment.points[segment.points.length-1];
  output.position.copy(arrival.position).lerp(segment.holdEnd.position,amount); output.target.copy(arrival.target); output.near=arrival.near; return output;
}
function tourFurnitureFrame() {
  const g=viewerTour.geometry,box=new THREE.Box3();viewerTour.furnitureKeys.forEach(key=>box.union(tourAddonBounds(key)));
  if(box.isEmpty())return {position:g.inside.clone(),target:g.insideTarget.clone()};
  const target=box.getCenter(new THREE.Vector3()),size=box.getSize(new THREE.Vector3()),tanV=Math.tan(camera.fov*Math.PI/360),tanH=tanV*camera.aspect;
  const y=Math.min(g.box.max.y-.23,Math.max(box.max.y+.28,g.box.min.y+g.size.y*.79));
  const z=Math.max(g.box.max.z+.35,box.max.z+Math.max(size.x/(2*tanH*.84),size.y/(2*tanV*.80)));
  return {position:new THREE.Vector3(target.x,y,z),target};
}
function tourFurniturePose(key, progress=0) {
  const frame=viewerTour.furnitureFrame||(viewerTour.furnitureFrame=tourFurnitureFrame()),position=frame.position.clone();
  position.x+=(progress-.5)*.055;return tourPoint(position,frame.target,viewerTour.geometry.near);
}
function tourWallFeaturePose(box) {
  const g=viewerTour.geometry,target=box.getCenter(new THREE.Vector3()),furnitureBox=tourAddonBounds(viewerTour.furnitureKeys[0]);
  const position=target.clone(),side=Math.min(target.x-g.box.min.x,g.box.max.x-target.x),rear=target.z-g.box.min.z;
  if(side<rear){position.x+=target.x<g.center.x?.48:-.48;position.z+=.14;}else position.z+=.48;
  position.x=Math.max(g.box.min.x+.16,Math.min(g.box.max.x-.16,position.x));position.z=Math.max(g.box.min.z+.16,Math.min(g.box.max.z-.2,position.z));
  position.y=Math.min(g.box.max.y-.3,Math.max(target.y+.17,furnitureBox.isEmpty()?0:furnitureBox.max.y+.12));
  return tourPoint(position,target,g.near);
}
function tourCeilingPose() {
  const g=viewerTour.geometry,light=g.features.lightPair||g.features.light,vent=TOUR_CEILING_VENTS[climateModelKey],center=light.getCenter(new THREE.Vector3()),points=[];
  [light,...(vent?[{min:{x:vent.min[0],y:vent.min[1],z:vent.min[2]},max:{x:vent.max[0],y:vent.max[1],z:vent.max[2]}}]:[])].forEach(box=>{for(const x of [box.min.x,box.max.x])for(const y of [box.min.y,box.max.y])for(const z of [box.min.z,box.max.z])points.push([x,y,z]);});
  const tanV=Math.tan(camera.fov*Math.PI/360),tanH=tanV*camera.aspect;let best=null,bestScore=Infinity;
  for(const height of [.66,.62,.58,.54,.50])for(const side of [0,.07,-.07])for(const blend of [.2,.1,0]){
    const position=new THREE.Vector3(g.center.x+g.size.x*side,g.box.min.y+g.size.y*height,g.box.max.z-.09),target=center.clone();if(vent)target.lerp(new THREE.Vector3(...vent.center),blend);
    const dx=target.x-position.x,dy=target.y-position.y,dz=target.z-position.z,length=Math.hypot(dx,dy,dz),fx=dx/length,fy=dy/length,fz=dz/length,rl=Math.hypot(fz,fx),rx=-fz/rl,rz=fx/rl,ux=-rz*fy,uy=rz*fx-rx*fz,uz=rx*fy;
    let score=0;points.forEach(point=>{const x=point[0]-position.x,y=point[1]-position.y,z=point[2]-position.z,depth=x*fx+y*fy+z*fz;score=Math.max(score,depth<=.02?Infinity:Math.abs((x*rx+z*rz)/(depth*tanH)),depth<=.02?Infinity:Math.abs((x*ux+y*uy+z*uz)/(depth*tanV)));});
    if(score<bestScore){bestScore=score;best=tourPoint(position,target);}if(score<=.88)return best;
  }
  return best||tourPoint(g.inside,center);
}
function buildTourSegments(start) {
  const g=viewerTour.geometry,v=(x,y,z)=>new THREE.Vector3(x,y,z),segments=[];viewerTour.furnitureFrame=null;
  let previous=tourCopyPose(start);
  const holds={roof_vents:1400,wheels:1600,magnetic_close:2700,occupancy:3000,rear_glass:1500,power:2200,control_panel:2200,lighting:2000,ventilation:3000,furniture:2500,furniture_detail:2500};
  const add=(key,travelDuration,end,waypoints=[],furnitureKey='')=>{
    const holdDuration=holds[key]||0,holdEnd=tourCopyPose(end);
    if(holdDuration){holdEnd.position.x+=key==='wheels'?.012:key==='power'||key==='control_panel'?(end.position.x<g.center.x?.012:-.012):furnitureKey?.006:.018;}
    const furnitureNodes=furnitureKey?(addonParents[furnitureKey]||[]).filter(node=>/seat|couch|chair|table|stol/i.test(node.name)&&!/nojk|no[gj]ka|arm_screen|karkas/i.test(node.name)):[];
    const anchor=furnitureKey?tourRepresentativeAnchor(furnitureNodes,end.target,true):key==='lighting'?g.anchors.light:key==='ventilation'?new THREE.Vector3(...TOUR_CEILING_VENTS[climateModelKey].center):key==='roof_vents'?g.anchors.roofVents:tourAnchoredStages.has(key)?end.target.clone():null;
    segments.push({key,duration:travelDuration+holdDuration,travelDuration,holdDuration,holdEnd,furnitureKey,anchor,points:[tourCopyPose(previous),...waypoints.map(tourCopyPose),tourCopyPose(end)]});previous=tourCopyPose(holdEnd);
  };
  if(viewerTour.mode==='furniture'){
    const key=viewerTour.furnitureKeys[0],first=tourFurniturePose(key,0),box=tourAddonBounds(key),position=g.inside.clone();
    position.x=g.doorInside.x;position.y=Math.min(g.box.max.y-.25,Math.max(position.y,box.isEmpty()?0:box.max.y+.18));
    const detailNodes=(addonParents[key]||[]).filter(node=>/seat|couch|chair|table|stol/i.test(node.name)&&!/nojk|no[gj]ka|arm_screen|karkas/i.test(node.name)),target=tourRepresentativeAnchor(detailNodes,first.target,true),last=tourPoint(position,target);
    add('furniture',2800,first,tourSafePath(start,first).slice(1,-1),key);
    const doorway=[v(position.x,position.y,Math.min(previous.position.z,g.box.max.z+.65)),v(position.x,position.y,g.doorOutside.z),v(position.x,position.y,g.doorInside.z)].map(point=>tourPoint(point,target));
    add('furniture_detail',1700,last,doorway,key);
  }else{
    const overview=tourPoint(v(g.center.x+Math.sin(.48)*g.distance,g.center.y+g.distance*.15,g.center.z+Math.cos(.48)*g.distance),g.center,g.near);
    add('exterior',1800,overview,tourSafePath(start,overview).slice(1,-1));
    if(!g.features.roofVents.isEmpty()){
      const target=g.features.roofVents.getCenter(new THREE.Vector3());
      add('roof_vents',2000,tourPoint(v(g.center.x+g.size.x*.25,g.box.max.y+Math.max(.65,g.size.z*.4),g.box.max.z+.55),target),[tourPoint(v(g.center.x+g.size.x*.45,g.box.max.y+.7,g.box.max.z+.75),target)]);
    }
    if(g.detail.wheel){const target=v(...g.detail.wheel);add('wheels',2100,tourPoint(v(Math.max(g.box.max.x+.055,target.x+.1),target.y+.018,target.z+.15),target),[tourPoint(v(g.box.max.x+.25,Math.max(.7,previous.position.y*.6),g.box.max.z+.75),target)]);}
    if(!g.features.handle.isEmpty()){
      const handle=g.features.handle.getCenter(new THREE.Vector3()),door=g.features.door.getCenter(new THREE.Vector3()),target=v((handle.x+door.x)/2,door.y,g.box.max.z);
      const end=tourPoint(v(door.x-.13,door.y+.16,g.box.max.z+Math.max(1.65,.72/(Math.tan(camera.fov*Math.PI/360)*camera.aspect))),target);
      const clear=v(Math.max(g.box.max.x+.08,previous.position.x),Math.max(.2,previous.position.y),g.box.max.z+.7);
      add('magnetic_close',1800,end,[tourPoint(clear,target)]);segments[segments.length-1].anchor=handle;
    }
    if(!g.features.occupancy.isEmpty()){
      const target=v(...TOUR_ORIGINAL_PARTS[climateModelKey].occupancy);
      add('occupancy',1400,tourPoint(v(target.x-.11,target.y-.08,g.box.max.z+.62),target));
    }
    const rearTarget=g.features.rearGlass.isEmpty()?g.insideTarget:g.features.rearGlass.getCenter(new THREE.Vector3()),rearAim=rearTarget.clone();if(!g.features.rearGlass.isEmpty())rearAim.x+=(g.features.rearGlass.max.x-g.features.rearGlass.min.x)*(camera.aspect<.9?.25:.1);const rearPose=tourPoint(g.inside,rearAim);
    add('rear_glass',2600,rearPose,tourSafePath(previous,rearPose).slice(1,-1));if(!g.features.rearGlass.isEmpty()){const anchor=rearTarget.clone();anchor.x=g.features.rearGlass.max.x-.025;segments[segments.length-1].anchor=anchor;}
    if(!g.features.power.isEmpty()){
      const end=tourWallFeaturePose(g.features.power),approach=end.position.clone();approach.y=Math.max(g.inside.y,end.position.y);
      add('power',1500,end,[tourPoint(approach,end.target)]);
    }
    if(!g.features.control.isEmpty())add('control_panel',700,tourWallFeaturePose(g.features.control));
    if(!g.features.light.isEmpty()){
      const ceiling=tourCeilingPose();add('lighting',1500,ceiling);const ventilation=tourCopyPose(ceiling);ventilation.position.x+=.032;add('ventilation',600,ventilation);
    }
    viewerTour.furnitureKeys.forEach((key,index)=>{
      const end=tourFurniturePose(key,index/Math.max(1,viewerTour.furnitureKeys.length-1));
      add(index?'furniture_detail':'furniture',index?850:2200,end,index?[]:tourSafePath(previous,end).slice(1,-1),key);
    });
  }
  const overview=tourPoint(v(g.center.x+Math.sin(.62)*g.distance,g.center.y+g.distance*.16,g.center.z+Math.cos(.62)*g.distance),g.center,g.near);
  add('complete',viewerTour.mode==='furniture'?2500:3000,overview,tourSafePath(previous,overview).slice(1,-1));
  if(viewerTour.mode==='full'){
    const holdsTotal=segments.reduce((sum,segment)=>sum+segment.holdDuration,0),travelTotal=segments.reduce((sum,segment)=>sum+segment.travelDuration,0),scale=Math.max(1,(40000-holdsTotal)/travelTotal);
    segments.forEach(segment=>{segment.travelDuration*=scale;segment.duration=segment.travelDuration+segment.holdDuration;});
  }
  return segments;
}
function applyTourPose(pose) {
  camera.position.copy(pose.position); controls.target.copy(pose.target);
  if (camera.near !== pose.near) { camera.near = pose.near; camera.updateProjectionMatrix(); }
  controls.update();
}
function tourControls(playing, restore = false) {
  if (!viewerTour || !controls) return;
  if (playing) { controls.enableDamping = false; controls.autoRotate = false; controls.update(); controls.enabled = false; controls.minDistance = 0; controls.maxDistance = Infinity; }
  else {
    Object.assign(controls, viewerTour.saved.controls);
    if (!restore) { if (tourIsInside(camera.position)) controls.minDistance = 0; controls.maxDistance = Math.max(controls.maxDistance, Math.sqrt(camera.position.distanceToSquared(controls.target)) * 1.05); }
  }
}
function tourSetFurniture(key) {
  if (!viewerTour || !addonParents[key]) return false;
  const changed = viewerTour.furnitureKey !== key;
  Object.entries(addonParents).forEach(([group,nodes]) => nodes.forEach(node => { node.visible = group === key; }));
  currentAddonKey = key; viewerTour.furnitureKey = key;
  return changed;
}
function tourDoorPartition(node,cut) {
  const position=node.geometry?.attributes?.position,index=node.geometry?.index;if(!position)return null;
  const count=index?index.count:position.count,world=new THREE.Vector3(),moving=[],fixed=[];
  for(let i=0;i+2<count;i+=3){
    const triangle=[index?index.getX(i):i,index?index.getX(i+1):i+1,index?index.getX(i+2):i+2];let inside=0;
    triangle.forEach(vertex=>{world.fromBufferAttribute(position,vertex).applyMatrix4(node.matrixWorld);if((cut[0]===null||world.x>=cut[0])&&(cut[1]===null||world.x<=cut[1]))inside++;});
    if(inside!==0&&inside!==3)return null;(inside===3?moving:fixed).push(...triangle);
  }
  return moving.length?{moving,fixed}:null;
}
function tourCloneMaterial(original) {
  const copy=original.clone();copy.onBeforeCompile=original.onBeforeCompile;copy.customProgramCacheKey=original.customProgramCacheKey;return copy;
}
function prepareTourParts() {
  if(!viewerTour||!scene||!THREE.Group)return;
  const spec=TOUR_ORIGINAL_PARTS[climateModelKey];if(!spec)return;
  const nodes=[];currentModel.traverse(node=>{if(node.isMesh)nodes.push(node)});
  viewerTour.parts={objects:[],geometries:[],materials:[],glass:[],indicators:[],doorMaterials:[]};viewerTour.hiddenOriginals=new Map();
  const parts=viewerTour.parts,front=nodes.find(node=>/^Interior_Glass$/i.test(node.name)),rim=nodes.find(node=>/^Exterior_ramka$/i.test(node.name)),handle=nodes.find(node=>/^Exterior_ruc[hck]+a$/i.test(node.name));
  const materialClone=new Map();
  const trackGlass=node=>{
    const original=node.material;if(!original||Array.isArray(original))return;
    let preview=materialClone.get(original);if(!preview){preview=tourCloneMaterial(original);preview.transparent=true;preview.depthWrite=false;materialClone.set(original,preview);parts.materials.push(preview);}
    parts.glass.push({node,original,preview});
  };
  if(front)trackGlass(front);
  const partition=front&&rim&&handle?tourDoorPartition(front,spec.cut):null;
  if(partition){
    const pivot=new THREE.Vector3(spec.hinge[0],0,spec.hinge[1]),group=new THREE.Group();group.name='FocusPodTourDoor';group.position.copy(pivot);scene.add(group);parts.objects.push(group);
    const clone=(node,indices,moving)=>{
      const geometry=node.geometry.clone();if(indices)geometry.setIndex(indices);geometry.clearGroups();geometry.applyMatrix4(node.matrixWorld);if(moving)geometry.translate(-pivot.x,0,-pivot.z);
      const material=moving?tourCloneMaterial(node.material):node.material;if(moving){parts.materials.push(material);parts.doorMaterials.push({original:node.material,preview:material});}
      const mesh=new THREE.Mesh(geometry,material);mesh.name='FocusPodTour_'+node.name;mesh.renderOrder=node.renderOrder;parts.geometries.push(geometry);
      if(moving)group.add(mesh);else{scene.add(mesh);parts.objects.push(mesh);}if(node===front)trackGlass(mesh);return mesh;
    };
    clone(front,partition.moving,true);if(partition.fixed.length)clone(front,partition.fixed,false);clone(rim,null,true);clone(handle,null,true);
    const sticker=nodes.find(node=>node.userData.focusPodSticker||node.name==='FocusPod_Front_Glass_Sticker');
    if(sticker){const box=tourMeshBounds([sticker]),center=box.getCenter(new THREE.Vector3());if((spec.cut[0]===null||center.x>=spec.cut[0])&&(spec.cut[1]===null||center.x<=spec.cut[1])){clone(sticker,null,true);viewerTour.hiddenOriginals.set(sticker,sticker.visible);sticker.visible=false;}}
    [front,rim,handle].forEach(node=>{viewerTour.hiddenOriginals.set(node,node.visible);node.visible=false;});viewerTour.door={group,pivot,partition};
  }
  nodes.filter(node=>/exterior_green[ _]?light/i.test(node.name)).forEach(node=>{
    const original=node.material;if(!original||Array.isArray(original))return;const preview=new THREE.MeshBasicMaterial({color:0x39ad60,toneMapped:false,fog:false,side:original.side,transparent:original.transparent,opacity:original.opacity});parts.materials.push(preview);parts.indicators.push({node,original,preview});
  });
}
function clearTourParts() {
  if(!viewerTour?.parts)return;
  const parts=viewerTour.parts;parts.glass.forEach(item=>{item.node.material=item.original});parts.indicators.forEach(item=>{item.node.material=item.original});
  viewerTour.hiddenOriginals.forEach((visible,node)=>{node.visible=visible});parts.objects.forEach(object=>scene.remove(object));parts.geometries.forEach(geometry=>geometry.dispose());parts.materials.forEach(material=>material.dispose());
  viewerTour.parts=null;viewerTour.door=null;viewerTour.hiddenOriginals.clear();
}
function updateTourDemonstrations(emit=true) {
  if(!viewerTour)return;
  const segment=viewerTour.segments[viewerTour.index],key=segment.key,hold=Math.max(0,viewerTour.elapsed-segment.travelDuration),clamp=value=>Math.max(0,Math.min(1,value)),ease=value=>{const p=clamp(value);return p*p*(3-2*p)};
  let occupancyState='';if(key==='occupancy'&&viewerTour.elapsed>=segment.travelDuration)occupancyState=!viewerTour.reducedMotion&&hold>=1500?'occupied':'available';
  const changed=viewerTour.occupancyState!==occupancyState;viewerTour.occupancyState=occupancyState;
  if(viewerTour.parts){
    viewerTour.parts.indicators.forEach(item=>{
      item.node.material=occupancyState?item.preview:item.original;
      if(occupancyState){const hex=occupancyState==='occupied'?0xe34336:0x39ad60;item.preview.color.setHex(hex);if(item.preview.emissive)item.preview.emissive.setHex(hex);item.preview.emissiveIntensity=.65;}
    });
    const furniture=Boolean(segment.furnitureKey),complete=key==='complete',preview=furniture||complete;
    const amount=furniture?(viewerTour.reducedMotion||viewerTour.index>0&&viewerTour.segments[viewerTour.index-1].furnitureKey?1:ease(viewerTour.elapsed/650)):complete?1-ease(viewerTour.elapsed/650):0;
    viewerTour.parts.doorMaterials.forEach(item=>{item.preview.opacity=item.original.opacity*(1-amount);const transparent=item.original.transparent||amount>0;if(item.preview.transparent!==transparent){item.preview.transparent=transparent;item.preview.needsUpdate=true;}item.preview.depthWrite=item.original.depthWrite&&amount===0;});if(viewerTour.door)viewerTour.door.group.visible=amount<.999;
    viewerTour.parts.glass.forEach(item=>{item.node.material=preview?item.preview:item.original;if(preview){item.preview.opacity=item.original.opacity*(1-amount);item.preview.roughness=item.original.roughness*(1-amount);}});
  }
  if(viewerTour.door){
    let angle=0;
    if(key==='magnetic_close'&&!viewerTour.reducedMotion){angle=viewerTour.elapsed<segment.travelDuration?.85*ease(viewerTour.elapsed/segment.travelDuration):.85*(1-ease((hold-500)/1300));}
    else if(key==='rear_glass')angle=1.32*(viewerTour.reducedMotion?1:ease(viewerTour.elapsed/650));
    else if(['power','control_panel','lighting','ventilation','furniture','furniture_detail'].includes(key))angle=1.32*(viewerTour.mode==='furniture'&&key==='furniture'&&!viewerTour.reducedMotion?ease(viewerTour.elapsed/650):1);
    else if(key==='complete')angle=0;
    viewerTour.door.group.rotation.y=angle;
  }
  if(changed&&emit)emitTourState();
}
function clearViewerContactShadow() {
  if (!viewerContactShadow) return;
  scene.remove(viewerContactShadow); viewerContactShadow.geometry.dispose(); viewerContactShadow.material.map.dispose(); viewerContactShadow.material.dispose(); viewerContactShadow=null;
}
function createViewerContactShadow() {
  clearViewerContactShadow();
  if (document.body.dataset.fpMarket!=='AU' || !currentModel) return;
  const exterior=currentModel.getObjectByName('EXTERIOR'); if(!exterior)return;
  currentModel.updateMatrixWorld(true);const bounds=new THREE.Box3().setFromObject(exterior),size=bounds.getSize(new THREE.Vector3()),center=bounds.getCenter(new THREE.Vector3());
  const canvas=document.createElement('canvas');canvas.width=128;canvas.height=128;const context=canvas.getContext('2d');if(!context)return;
  const gradient=context.createRadialGradient(64,64,4,64,64,64);gradient.addColorStop(0,'rgba(66,59,49,0.22)');gradient.addColorStop(.55,'rgba(66,59,49,0.13)');gradient.addColorStop(1,'rgba(66,59,49,0)');context.fillStyle=gradient;context.fillRect(0,0,128,128);
  const texture=new THREE.CanvasTexture(canvas);texture.encoding=THREE.sRGBEncoding;
  const material=new THREE.MeshBasicMaterial({map:texture,transparent:true,depthWrite:false,toneMapped:false,fog:false,opacity:1,side:THREE.FrontSide});
  viewerContactShadow=new THREE.Mesh(new THREE.PlaneGeometry(size.x*1.45,size.z*1.45),material);viewerContactShadow.name='FocusPodContactShadow';viewerContactShadow.rotation.x=-Math.PI/2;viewerContactShadow.position.set(center.x,bounds.min.y+.002,center.z);viewerContactShadow.userData.baseY=bounds.min.y;scene.add(viewerContactShadow);updateViewerContactShadow(true);
}
function updateViewerContactShadow(immediate = false) {
  if(!viewerContactShadow||!camera)return;
  const low=camera.position.y<=viewerContactShadow.userData.baseY+.12, target=low||viewerTour?.segments[viewerTour.index]?.key==='wheels'?0:1;
  const material=viewerContactShadow.material;material.opacity=immediate||low?target:material.opacity+(target-material.opacity)*.16;viewerContactShadow.visible=material.opacity>.001;
}
function stopTour(options = {}) {
  if (!viewerTour) return tourStatus();
  const saved = viewerTour.saved; viewerTour.move = null; clearTourParts(); tourControls(false,true);
  if (saved.modelVersion === regionalLoadVersion) { saved.addons.forEach(([node,visible]) => { node.visible=visible; }); currentAddonKey=saved.addonKey; }
  if (camera && controls) {
    const damping=controls.enableDamping; controls.enableDamping=false; controls.update();
    if (options.restore !== false && currentModel && saved.modelVersion === regionalLoadVersion) {
      camera.position.copy(saved.position); controls.target.copy(saved.target);
      if (saved.outside && saved.aspect > camera.aspect) {
        const vertical=camera.fov*Math.PI/360, oldHalf=Math.min(vertical,Math.atan(Math.tan(vertical)*saved.aspect)), newHalf=Math.min(vertical,Math.atan(Math.tan(vertical)*camera.aspect)), scale=Math.sin(oldHalf)/Math.sin(newHalf);
        camera.position.set(saved.target.x+(saved.position.x-saved.target.x)*scale,saved.target.y+(saved.position.y-saved.target.y)*scale,saved.target.z+(saved.position.z-saved.target.z)*scale);
        controls.maxDistance=Math.max(controls.maxDistance,Math.sqrt(camera.position.distanceToSquared(controls.target))*1.05);
      }
    }
    camera.near=saved.near; camera.updateProjectionMatrix(); controls.update(); controls.enableDamping=damping;
  }
  viewerTour=null; updateViewerContactShadow(true); emitTourState(); return tourStatus();
}
function pauseTour(reason) {
  if (!viewerTour || (viewerTour.status==='complete'&&!viewerTour.move)) return tourStatus();
  const changed=viewerTour.status!=='paused'||Boolean(viewerTour.move), complete=viewerTour.status==='complete';
  viewerTour.status=complete?'complete':'paused'; viewerTour.last=null; viewerTour.move=null; tourControls(false);
  if(changed)emitTourState(); return tourStatus();
}
function tourMoveTo(pose) {
  tourControls(true); viewerTour.move={elapsed:0,duration:1400,points:tourSafePath(tourCurrentPose(),pose)}; viewerTour.last=null;
}
function enterTourStop(index, playing, manual) {
  viewerTour.index=index; viewerTour.last=null; viewerTour.move=null;
  const segment=viewerTour.segments[index]; if(segment.furnitureKey)tourSetFurniture(segment.furnitureKey);
  viewerTour.status=playing?'playing':segment.key==='complete'?'complete':'paused';
  viewerTour.elapsed=playing&&!viewerTour.reducedMotion?0:segment.duration;
  const pose=tourSegmentPose(segment,viewerTour.elapsed,viewerTour.pose);
  tourControls(true);
  if(manual&&!viewerTour.reducedMotion)tourMoveTo(pose);
  else {applyTourPose(pose);if(!playing)tourControls(false);}
  updateTourDemonstrations(false); emitTourState();
}
function startTour(options = {}) {
  if(document.body.dataset.fpMarket!=='AU'||!currentModel||!viewerTourReady||!camera||!controls||document.hidden)return false;
  const previousSaved=viewerTour?.saved; if(viewerTour)stopTour({restore:false,reason:'replay'});
  const valid=Object.keys(addonParents).filter(key=>addonParents[key].length), preferred=valid.includes(options.furnitureKey)?options.furnitureKey:valid.includes('Addon1')?'Addon1':valid[0];
  const furnitureKeys=[...new Set([preferred,...(Array.isArray(options.furnitureKeys)?options.furnitureKeys:[])].filter(key=>valid.includes(key)))];
  const mode=options.mode==='furniture'?'furniture':'full'; if(mode==='furniture'&&!preferred)return false;
  const before=tourCurrentPose(), saved=previousSaved||{...tourCopyPose(before),aspect:camera.aspect,modelVersion:regionalLoadVersion,addonKey:currentAddonKey,addons:Object.values(addonParents).flat().map(node=>[node,node.visible]),
    controls:{enabled:controls.enabled,enableDamping:controls.enableDamping,autoRotate:controls.autoRotate,minDistance:controls.minDistance,maxDistance:controls.maxDistance}};
  viewerTour={saved,mode,furnitureKeys:mode==='furniture'?furnitureKeys.slice(0,1):furnitureKeys,furnitureKey:'',reducedMotion:Boolean(options.reducedMotion),status:'paused',index:0,elapsed:0,last:null,move:null,segments:[],
    pose:{position:new THREE.Vector3(),target:new THREE.Vector3(),near:saved.near}};
  if(preferred)tourSetFurniture(preferred); const geometry=tourGeometry(); if(!geometry){stopTour({restore:true,reason:'bounds'});return false;}
  viewerTour.geometry=geometry; if(saved.outside===undefined)saved.outside=!tourIsInside(saved.position,geometry);
  viewerTour.segments=buildTourSegments(before); prepareTourParts();
  enterTourStop(0,!viewerTour.reducedMotion,false);return true;
}
function resumeTour() {
  if(!viewerTour||viewerTour.status!=='paused'||viewerTour.reducedMotion||document.hidden)return false;
  const segment=viewerTour.segments[viewerTour.index],pose=tourSegmentPose(segment,viewerTour.elapsed,viewerTour.pose);
  const moved=camera.position.distanceToSquared(pose.position)>.0001||controls.target.distanceToSquared(pose.target)>.0001;
  viewerTour.status='playing';viewerTour.last=null;tourControls(true);if(moved)tourMoveTo(pose);emitTourState();return true;
}
function setTourReducedMotion(value) {
  if(!viewerTour)return tourStatus();pauseTour('motion-preference');viewerTour.reducedMotion=Boolean(value);
  if(viewerTour.reducedMotion)enterTourStop(viewerTour.index,false,false);emitTourState();return tourStatus();
}
function tourGo(index) {
  if(!viewerTour||!Number.isInteger(index)||index<0||index>=viewerTour.segments.length)return false;
  enterTourStop(index,false,true);return true;
}
function resizeTour() {
  if(!viewerTour)return;pauseTour('resize');const geometry=tourGeometry();if(!geometry){stopTour({restore:true,reason:'bounds'});return;}
  const old=viewerTour.segments[viewerTour.index],progress=viewerTour.elapsed/old.duration;
  viewerTour.geometry=geometry;viewerTour.segments=buildTourSegments({position:viewerTour.saved.position,target:viewerTour.saved.target,near:viewerTour.saved.near});
  const matching=viewerTour.segments.findIndex(segment=>segment.key===old.key&&segment.furnitureKey===old.furnitureKey);
  viewerTour.index=matching<0?Math.min(viewerTour.index,viewerTour.segments.length-1):matching;
  const segment=viewerTour.segments[viewerTour.index];viewerTour.elapsed=segment.duration*progress;
  tourControls(true);applyTourPose(tourSegmentPose(segment,viewerTour.elapsed,viewerTour.pose));tourControls(false);updateTourDemonstrations(false);emitTourState();
}
function advanceTour(now) {
  if(!viewerTour||(!viewerTour.move&&viewerTour.status!=='playing'))return;
  const dt=viewerTour.last===null?0:Math.max(0,Math.min(64,now-viewerTour.last));viewerTour.last=now;
  if(viewerTour.move){const move=viewerTour.move;move.elapsed=Math.min(move.duration,move.elapsed+dt);applyTourPose(tourSample(move.points,move.elapsed/move.duration,viewerTour.pose));if(move.elapsed===move.duration){viewerTour.move=null;if(viewerTour.status!=='playing')tourControls(false);}return;}
  const segment=viewerTour.segments[viewerTour.index];viewerTour.elapsed=Math.min(segment.duration,viewerTour.elapsed+dt);applyTourPose(tourSegmentPose(segment,viewerTour.elapsed,viewerTour.pose));
  if(viewerTour.elapsed<segment.duration)return;
  if(segment.key==='complete'){viewerTour.status='complete';viewerTour.last=null;tourControls(false);emitTourState();}
  else enterTourStop(viewerTour.index+1,true,false);
}


// HDR hardcoded — Shopify Files CDN URL
var ASSET_HDR    = 'https://cdn.shopify.com/s/files/1/0921/9237/5151/files/cannon_1k.hdr?v=1773620901';
var _assets      = document.getElementById('focuspod-assets');
var ASSET_FABRIC = _assets ? _assets.dataset.fabric : 'tkan.jpg';

// Fabric texture — preloaded once, reused across all models
const textureLoader = new THREE.TextureLoader();
const seatTexture = textureLoader.load(ASSET_FABRIC);
// meshMap tracks all meshes by name so interior colour click can find seats
let meshMap = new Map();

const FOCUSPOD_STICKER_URL = 'https://cdn.shopify.com/s/files/1/0921/9237/5151/files/Untitled_design_7.png?v=1753192274';
const FOCUSPOD_STICKER_PLACEMENT = {
  solo: { x: 0.5, y: 0.10, width: 0.55 },
  'solo-plus': { x: 0.24, y: 0.087, width: 0.30 },
  duo: { x: 0.23, y: 0.085, width: 0.30 },
  team: { x: 0.145, y: 0.08, width: 0.205 },
  meet: { x: 0.15, y: 0.08, width: 0.21 },
  max: { x: 0.155, y: 0.075, width: 0.22 }
};
if (window.FocusPodReplacement) {
  Object.assign(FOCUSPOD_STICKER_PLACEMENT['solo-plus'], {x:0.17,y:0.04,width:0.26});
  Object.assign(FOCUSPOD_STICKER_PLACEMENT.duo, {x:0.17,y:0.04,width:0.26});
}
let focusPodStickerMaterial;
function addFocusPodSticker(model, modelKey) {
  const placement = FOCUSPOD_STICKER_PLACEMENT[modelKey];
  if (!placement || model.getObjectByName('FocusPod_Front_Glass_Sticker')) return;
  model.updateMatrixWorld(true);
  const panels = [];
  model.traverse(node => {
    if (node.isMesh && (node.userData.focuspodMaterial === 'glass' || /^(?:steklo(?:_[rl])?|(?:interior_|exterior_)?glass(?:[._]?\d+|_blur)?)$/i.test(node.name))) {
      const box = new THREE.Box3().setFromObject(node);
      panels.push({ node, box, z: box.getCenter(new THREE.Vector3()).z });
    }
  });
  if (!panels.length) return;
  const frontZ = Math.max(...panels.map(panel => panel.z));
  const rearZ = Math.min(...panels.map(panel => panel.z));
  const front = panels.filter(panel => panel.z >= (frontZ + rearZ) / 2);
  const bounds = new THREE.Box3();
  front.forEach(panel => bounds.union(panel.box));
  const size = bounds.getSize(new THREE.Vector3());
  const origin = new THREE.Vector3(bounds.min.x + size.x * placement.x, bounds.min.y + size.y * placement.y, bounds.max.z + size.y);
  const ray = new THREE.Raycaster(origin, new THREE.Vector3(0, 0, -1));
  const hit = ray.intersectObjects(front.map(panel => panel.node), false)[0];
  if (!hit) return;
  if (!focusPodStickerMaterial) {
    const texture = textureLoader.load(FOCUSPOD_STICKER_URL);
    texture.encoding = THREE.sRGBEncoding;
    texture.offset.set(64 / 1024, 0);
    texture.repeat.set(908 / 1024, 1);
    focusPodStickerMaterial = new THREE.MeshBasicMaterial({ map: texture, color: 0xffffff, transparent: true, alphaTest: 0.02, depthWrite: false, side: THREE.DoubleSide, toneMapped: false });
    focusPodStickerMaterial.onBeforeCompile = shader => {
      shader.fragmentShader = shader.fragmentShader.replace('#include <map_fragment>', '#include <map_fragment>\ndiffuseColor.rgb = vec3(1.0);');
    };
    focusPodStickerMaterial.customProgramCacheKey = () => 'focuspod-white-glass-sticker-v1';
  }
  const width = size.x * placement.width;
  const sticker = new THREE.Mesh(new THREE.PlaneGeometry(width, width / (908 / 200)), focusPodStickerMaterial);
  sticker.name = 'FocusPod_Front_Glass_Sticker';
  const normal = hit.face.normal.clone().transformDirection(hit.object.matrixWorld);
  if (normal.z < 0) normal.negate();
  sticker.position.copy(model.worldToLocal(hit.point.clone().addScaledVector(normal, 0.001)));
  const modelRotation = model.getWorldQuaternion(new THREE.Quaternion()).invert();
  sticker.quaternion.copy(modelRotation.multiply(new THREE.Quaternion().setFromUnitVectors(new THREE.Vector3(0, 0, 1), normal)));
  sticker.renderOrder = 10;
  sticker.userData.focusPodSticker = true;
  model.add(sticker);
}


const ATOM_IMAGE_APPEARANCE = {"solo":{"cornerLights":["NAUO5_8","NAUO5_9"],"rearGlass":{"frames":[],"joints":[]},"cornerCovers":["NAUO5_0","NAUO5_3"]},"solo-plus":{"cornerLights":["NAUO5_4","NAUO5_5"],"rearGlass":{"frames":["NAUO19_0","NAUO20_0"],"joints":[0]},"cornerCovers":["NAUO5_0","NAUO5_3"]},"duo":{"cornerLights":["NAUO5_4","NAUO5_5"],"rearGlass":{"frames":["NAUO19_0","NAUO20_0"],"joints":[0]},"cornerCovers":["NAUO5_0","NAUO5_3"]},"team":{"cornerLights":["NAUO5_4","NAUO5_5"],"rearGlass":{"frames":["NAUO17_0","NAUO32_1","NAUO33_1"],"joints":[-0.48,0.48]},"cornerCovers":["NAUO5_0","NAUO5_3"]},"meet":{"cornerLights":["NAUO4_4","NAUO4_5"],"rearGlass":{"frames":["NAUO16_0","NAUO28_0","NAUO29_0"],"joints":[-0.48,0.48]},"cornerCovers":["NAUO4_0","NAUO4_3"]},"max":{"cornerLights":["NAUO4_4","NAUO4_5"],"rearGlass":{"frames":["NAUO16_0","NAUO30_0","NAUO31_0"],"joints":[-0.48,0.48]},"cornerCovers":["NAUO4_0","NAUO4_3"]}};
function softenRearGlassJoints(node, joints) {
  const geometry = node.geometry.clone();
  const positions = geometry.getAttribute('position');
  const source = geometry.index ? Array.from(geometry.index.array) : Array.from({ length: positions.count }, (_, i) => i);
  const frame = [], seams = [];
  for (let i = 0; i < source.length; i += 3) {
    const triangle = source.slice(i, i + 3);
    const xs = triangle.map(index => positions.getX(index));
    const ys = triangle.map(index => positions.getY(index));
    const rear = triangle.every(index => positions.getZ(index) < 0);
    const isJoint = rear && Math.max(...ys) - Math.min(...ys) > 0.1 &&
      joints.some(x => xs.every(value => Math.abs(value - x) < 0.025));
    (isJoint ? seams : frame).push(...triangle);
  }
  if (!seams.length) return;
  geometry.setIndex(frame.concat(seams));
  geometry.clearGroups();
  geometry.addGroup(0, frame.length, 0);
  geometry.addGroup(frame.length, seams.length, 1);
  const seam = new THREE.MeshStandardMaterial({
    color: 0xc4cdcf, transparent: true, opacity: 0.06, depthWrite: false,
    metalness: 0, roughness: 0.1, side: THREE.DoubleSide
  });
  node.geometry = geometry;
  node.material = [node.material, seam];
  node.castShadow = false;
}


function revealCornerLens(cover, lens) {
  // Surface the CAD lens through its opaque cover using the existing corner
  // geometry, clipped to the lens's exact five-millimetre vertical bounds.
  lens.geometry.computeBoundingBox();
  const bounds = lens.geometry.boundingBox;
  const geometry = cover.geometry, position = geometry.getAttribute('position');
  if (!geometry.getAttribute('normal')) geometry.computeVertexNormals();
  const normal = geometry.getAttribute('normal');
  const source = geometry.index ? Array.from(geometry.index.array) : Array.from({length: position.count}, (_, i) => i);
  const clip = (polygon, limit, above) => {
    const out = [];
    for (let i = 0; i < polygon.length; i++) {
      const a = polygon[i], b = polygon[(i + 1) % polygon.length];
      const aIn = above ? a.p.y >= limit : a.p.y <= limit;
      const bIn = above ? b.p.y >= limit : b.p.y <= limit;
      if (aIn) out.push(a);
      if (aIn !== bIn) {
        const t = (limit - a.p.y) / (b.p.y - a.p.y);
        out.push({p:a.p.clone().lerp(b.p,t), n:a.n.clone().lerp(b.n,t).normalize()});
      }
    }
    return out;
  };
  const vertices = [], normals = [];
  for (let i = 0; i < source.length; i += 3) {
    const triangle = source.slice(i,i+3).map(index => ({p:new THREE.Vector3().fromBufferAttribute(position,index), n:new THREE.Vector3().fromBufferAttribute(normal,index)}));
    const polygon = clip(clip(triangle,bounds.min.y,true),bounds.max.y,false);
    for (let j = 1; j + 1 < polygon.length; j++) {
      for (const vertex of [polygon[0],polygon[j],polygon[j+1]]) {
        vertices.push(...vertex.p.clone().addScaledVector(vertex.n,0.0005).toArray());
        normals.push(...vertex.n.toArray());
      }
    }
  }
  if (!vertices.length) return;
  const bandGeometry = new THREE.BufferGeometry();
  bandGeometry.setAttribute('position',new THREE.Float32BufferAttribute(vertices,3));
  bandGeometry.setAttribute('normal',new THREE.Float32BufferAttribute(normals,3));
  const band = new THREE.Mesh(bandGeometry,lens.material);
  band.name = cover.name + '_Corner_Lens';
  band.userData.focuspodMaterial = 'corner-light';
  cover.add(band);
}

function applyAtomImageAppearance(model, modelKey) {
  const viewerElement = document.getElementById('viewer');
  if (viewerElement) viewerElement.dataset.atomAppearance = window.FocusPodReplacement?.imageRange || 'original';
  if (window.FocusPodReplacement?.imageRange !== 'ATOM') return;
  const appearance = ATOM_IMAGE_APPEARANCE[modelKey];
  if (!appearance) return;
  for (const [index, name] of appearance.cornerLights.entries()) {
    const node = model.getObjectByName(name);
    if (!node?.isMesh) continue;
    exteriorMats = exteriorMats.filter(material => material !== node.material);
    node.material = new THREE.MeshStandardMaterial({
      color: new THREE.Color('#ff8500').convertSRGBToLinear(),
      emissive: new THREE.Color('#ff8500').convertSRGBToLinear(),
      emissiveIntensity: 0.65, roughness: 0.35, metalness: 0,
      toneMapped: false
    });
    node.userData.focuspodMaterial = 'corner-light';
    const cover = model.getObjectByName(appearance.cornerCovers[index]);
    if (cover?.isMesh) revealCornerLens(cover, node);
  }
  for (const name of appearance.rearGlass.frames) {
    const node = model.getObjectByName(name);
    if (node?.isMesh) softenRearGlassJoints(node, appearance.rearGlass.joints);
  }
}

function initViewer(initialModel = 'solo') {
  const canvas    = document.getElementById('viewer');
  const container = canvas.parentElement;

  scene = new THREE.Scene();
  scene.background = null;
  window.__fp_scene_ref = scene;  // exposed for info popup raycaster

  camera = new THREE.PerspectiveCamera(75, container.clientWidth / container.clientHeight, 0.1, 1000);
  camera.position.set(0, 1.5, 3);
  window.__fp_camera_ref = camera;  // exposed for info popup raycaster

  renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.setSize(container.clientWidth, container.clientHeight);
  renderer.shadowMap.enabled       = true;
  renderer.shadowMap.type          = THREE.PCFSoftShadowMap;
  renderer.toneMapping             = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure     = 1.5;
  renderer.outputEncoding          = THREE.sRGBEncoding;
  renderer.physicallyCorrectLights = true;

  // Load HDR environment
  var pmremGenerator = new THREE.PMREMGenerator(renderer);
  pmremGenerator.compileEquirectangularShader();
  var rgbeLoader = new THREE.RGBELoader();
  rgbeLoader.setDataType(THREE.UnsignedByteType);
  rgbeLoader.load(ASSET_HDR, function(hdrEquirect) {
    var envMap = pmremGenerator.fromEquirectangular(hdrEquirect).texture;
    scene.environment = envMap;
    hdrEquirect.dispose();
    pmremGenerator.dispose();
  }, undefined, function(err) {
    console.warn('[FocusPod] HDR failed to load, using lights only:', err);
  });

  controls = new THREE.OrbitControls(camera, renderer.domElement);
  controls.enableDamping = true;
  controls.dampingFactor = 0.25;
  controls.update();
  if (document.body.dataset.fpMarket === 'AU') {
    canvas.addEventListener('pointerdown', () => pauseTour('interaction'), { capture: true, passive: true });
    canvas.addEventListener('wheel', () => pauseTour('interaction'), { capture: true, passive: true });
  }

  // Lighting — exactly as QuietCubes
  var dirLight = new THREE.DirectionalLight(0xffffff, 0.8);
  dirLight.position.set(0, 20, 30);
  dirLight.castShadow = false;
  scene.add(dirLight);

  var ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
  scene.add(ambientLight);

  var plane = new THREE.Mesh(
    new THREE.PlaneGeometry(100, 100),
    new THREE.ShadowMaterial({ opacity: 0.06 })
  );
  plane.rotation.x = -Math.PI / 2;
  plane.receiveShadow = true;
  scene.add(plane);

  new ResizeObserver(function(entries) {
    var r = entries[0].contentRect;
    if (!r.width || !r.height) return;
    camera.aspect = r.width / r.height;
    camera.updateProjectionMatrix();
    renderer.setSize(r.width, r.height, false);
    if (viewerTour) resizeTour();
    else if (document.body.dataset.fpMarket === 'AU') setStudioView(studioCameraView, true);
  }).observe(container);

  // Rendering is only useful while the preview is visible. Keep one frame loop
  // and resume it when the preview returns, including after a cached-page visit.
  var viewerInView = true;
  var viewerPageActive = true;
  var viewerFrame = null;
  function viewerCanRender() {
    return viewerInView && viewerPageActive && !document.hidden;
  }
  function renderViewerFrame(now) {
    viewerFrame = null;
    if (!viewerCanRender()) return;
    advanceTour(now);
    updateTourDemonstrations();
    controls.update();
    updateViewerContactShadow();
    renderer.render(scene, camera);
    updateTourAnchor();
    viewerFrame = requestAnimationFrame(renderViewerFrame);
  }
  function syncViewerRendering() {
    viewerTourAnchorHidden = !viewerCanRender();
    if (!viewerCanRender()) pauseTour('visibility');
    if (viewerTour || viewerTourAnchor.active) updateTourAnchor(true);
    if (viewerCanRender()) {
      if (viewerFrame === null) viewerFrame = requestAnimationFrame(renderViewerFrame);
    } else if (viewerFrame !== null) {
      cancelAnimationFrame(viewerFrame);
      viewerFrame = null;
    }
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function(entries) {
      viewerInView = entries.some(function(entry) { return entry.isIntersecting; });
      syncViewerRendering();
    }, { rootMargin: '100px' }).observe(container);
  }
  document.addEventListener('visibilitychange', syncViewerRendering);
  window.addEventListener('pagehide', function() { viewerPageActive = false; syncViewerRendering(); });
  window.addEventListener('pageshow', function() { viewerPageActive = true; syncViewerRendering(); });
  syncViewerRendering();

  loadModel(initialModel);
}

let regionalLoadVersion = 0;

const REPLACEMENT_PANELS = {"solo":{"left":{"solid":["NAUO2_0","NAUO14_0","NAUO14_1","NAUO14_2","NAUO23_0"],"bays":[[-0.55,0.004,-0.455,-0.48,2.114,0.455]]},"right":{"solid":["NAUO6_0","NAUO22_0","NAUO30_0","NAUO30_1","NAUO30_2"],"bays":[[0.479996,0.003996,-0.455004,0.55,2.114004,0.455003]]},"felt":["NAUO14_0","NAUO14_1","NAUO14_2","NAUO22_0","NAUO23_0","NAUO30_0","NAUO30_1","NAUO30_2"]},"solo-plus":{"left":{"solid":["NAUO3_0","NAUO13_0","NAUO13_1","NAUO13_2","NAUO17_0","NAUO24_0"],"bays":[[-0.8,0.004,0.0,-0.73,2.114,0.605],[-0.800004,0.003996,-0.605004,-0.73,2.114004,3e-06]]},"right":{"solid":["NAUO6_0","NAUO14_0","NAUO14_1","NAUO14_2","NAUO18_0","NAUO25_0"],"bays":[[0.729996,0.003996,-3e-06,0.8,2.114004,0.605004],[0.729996,0.003996,-0.605003,0.8,2.114004,4e-06]]},"felt":["NAUO13_0","NAUO13_1","NAUO13_2","NAUO14_0","NAUO14_1","NAUO14_2","NAUO24_0","NAUO25_0"]},"duo":{"left":{"solid":["NAUO3_0","NAUO13_0","NAUO13_1","NAUO13_2","NAUO17_0","NAUO24_0"],"bays":[[-0.8,0.004,0.0,-0.73,2.114,0.605],[-0.800004,0.003996,-0.605004,-0.73,2.114004,3e-06]]},"right":{"solid":["NAUO6_0","NAUO14_0","NAUO14_1","NAUO14_2","NAUO18_0","NAUO25_0"],"bays":[[0.729996,0.003996,-3e-06,0.8,2.114004,0.605004],[0.729996,0.003996,-0.605003,0.8,2.114004,4e-06]]},"felt":["NAUO13_0","NAUO13_1","NAUO13_2","NAUO14_0","NAUO14_1","NAUO14_2","NAUO24_0","NAUO25_0"]},"team":{"left":{"solid":["NAUO3_0","NAUO13_0","NAUO13_1","NAUO13_2","NAUO21_0"],"bays":[[-1.125,0.005,-0.455,-1.059,2.115,0.455]]},"right":{"solid":["NAUO6_0","NAUO14_0","NAUO14_1","NAUO14_2","NAUO22_0"],"bays":[[1.058996,0.004996,-0.455003,1.125,2.115004,0.455004]]},"felt":["NAUO13_0","NAUO13_1","NAUO13_2","NAUO14_0","NAUO14_1","NAUO14_2","NAUO21_0","NAUO22_0"]},"meet":{"left":{"solid":["NAUO3_0","NAUO12_0","NAUO12_1","NAUO12_2","NAUO20_0","NAUO30_0"],"bays":[[-1.125,0.004,-0.0,-1.055,2.114,0.73],[-1.125004,0.003996,-0.730004,-1.055,2.114004,3e-06]]},"right":{"solid":["NAUO5_0","NAUO13_0","NAUO13_1","NAUO13_2","NAUO21_0","NAUO31_0","NAUO45_0"],"bays":[[1.054996,0.003996,-3e-06,1.125,2.114004,0.730004],[1.055,0.003996,-0.730003,1.125004,2.114004,4e-06]]},"felt":["NAUO12_0","NAUO12_1","NAUO12_2","NAUO13_0","NAUO13_1","NAUO13_2","NAUO20_0","NAUO21_0","NAUO45_0"]},"max":{"left":{"solid":["NAUO3_0","NAUO12_0","NAUO20_0","NAUO32_0","NAUO33_0","NAUO36_0","NAUO37_0"],"bays":[[-1.3,0.004,0.365,-1.23,2.114,1.095],[-1.300004,0.003996,-0.365004,-1.23,2.114004,0.365003],[-1.300004,0.003996,-1.095004,-1.23,2.114004,-0.364997]]},"right":{"solid":["NAUO5_0","NAUO13_0","NAUO21_0","NAUO34_0","NAUO35_0","NAUO38_0","NAUO39_0"],"bays":[[1.229996,0.003996,0.364997,1.3,2.114004,1.095004],[1.23,0.003996,-0.365003,1.300004,2.114004,0.365004],[1.23,0.003996,-1.095003,1.300004,2.114004,-0.364996]]},"felt":["NAUO12_0","NAUO13_0","NAUO20_0","NAUO21_0","NAUO33_0","NAUO34_0","NAUO36_0","NAUO38_0"]}};
let replacementPanelNodes = null;
function buildReplacementPanels(model, modelKey) {
  replacementPanelNodes = null;
  if (!window.FocusPodReplacement || !REPLACEMENT_PANELS[modelKey]) return;
  const spec = REPLACEMENT_PANELS[modelKey];
  const parts = {left:{solid:[],glass:[]},right:{solid:[],glass:[]},rear:{solid:[],glass:[]}};
  const addBox = (name, bounds, category, target) => {
    const size = bounds.slice(3).map((v,i)=>v-bounds[i]);
    const glass = category === 'glass';
    const mat = new THREE.MeshStandardMaterial({color:glass?0xd8e4e6:category==='interior'?0x8a8a8a:0xf0f0ee,roughness:glass?0:.65,metalness:glass?0:.1,transparent:glass,opacity:glass?.08:1,depthWrite:!glass});
    const node = new THREE.Mesh(new THREE.BoxGeometry(...size),mat);
    node.name=name;node.position.set(...bounds.slice(0,3).map((v,i)=>(v+bounds[i+3])/2));
    node.userData.focuspodMaterial=category;node.userData.focuspodPanel=name.split('_')[1];
    model.add(node);if(target)target.push(node);return node;
  };
  spec.felt.forEach(name=>{const n=model.getObjectByName(name);if(n)n.userData.focuspodMaterial='interior';});
  ['left','right'].forEach(side=>{
    parts[side].solid=spec[side].solid.map(name=>model.getObjectByName(name)).filter(Boolean);
    spec[side].bays.forEach((b,index)=>{
      const x=(b[0]+b[3])/2,y0=b[1]+.035,y1=b[4]-.035,z0=b[2]+.0175,z1=b[5]-.0175;
      addBox('Panel_'+side+'_glass_'+index,[x-.0055,y0,z0,x+.0055,y1,z1],'glass',parts[side].glass);
      addBox('Panel_'+side+'_top_'+index,[b[0],b[4]-.035,b[2],b[3],b[4],b[5]],'exterior',parts[side].glass);
      addBox('Panel_'+side+'_bottom_'+index,[b[0],b[1],b[2],b[3],b[1]+.035,b[5]],'exterior',parts[side].glass);
      [b[2],b[5]-.035].forEach((z,i)=>addBox('Panel_'+side+'_edge_'+index+'_'+i,[b[0],y0,z,b[3],y1,z+.035],'exterior',parts[side].glass));
    });
  });
  model.updateMatrixWorld(true);
  const rear=[];
  model.traverse(node=>{if(node.isMesh&&node.userData.focuspodMaterial==='glass'&&!node.userData.focuspodPanel){const b=new THREE.Box3().setFromObject(node);if(b.getCenter(new THREE.Vector3()).z<0)rear.push({node,b});}});
  rear.forEach(({node,b},index)=>{
    node.userData.focuspodPanel='rear';parts.rear.glass.push(node);
    const z=b.getCenter(new THREE.Vector3()).z;
    addBox('Panel_rear_outer_'+index,[b.min.x,b.min.y,z-.005,b.max.x,b.max.y,z+.05],'exterior',parts.rear.solid);
    addBox('Panel_rear_felt_'+index,[b.min.x+.006,b.min.y+.006,z+.05,b.max.x-.006,b.max.y-.006,z+.068],'interior',parts.rear.solid);
  });
  replacementPanelNodes=parts;
  setPanels({left:'solid',right:'solid',rear:'glass'});
}
function setPanels(selection) {
  if(!replacementPanelNodes)return;
  ['left','right','rear'].forEach(side=>{
    const kind=selection?.[side]==='glass'?'glass':'solid';
    ['solid','glass'].forEach(type=>replacementPanelNodes[side][type].forEach(node=>{node.visible=type===kind;}));
  });
}

function loadModel(modelKey) {
  clearViewerContactShadow();
  viewerTourReady = false;
  stopTour({ restore: false, reason: 'model' });
  if (document.body.dataset.fpMarket === 'AU') window.dispatchEvent(new CustomEvent('fp:viewer-loading', { detail: { model: modelKey } }));
  const loadVersion = ++regionalLoadVersion;
  var path = MODEL_FILES[modelKey];
  if (!path) return;
  showLoading(true);

  addonParents = {};
  currentAddonKey = 'Addon1';
  exteriorMats = []; interiorMats = []; seatMats = []; glassMats = []; glassFrontMats = []; glassRearMats = [];
  airconNode = null; airconNodes = []; ventilationNodes = []; climateModelKey = modelKey; glassNodes = []; pdlcVersion++;
  meshMap = new Map();

  if (currentModel) { currentModel.getObjectByName('FocusPod_Front_Glass_Sticker')?.geometry.dispose(); scene.remove(currentModel); currentModel = null; }

  var loader = new THREE.GLTFLoader();
  var draco  = new THREE.DRACOLoader();
  draco.setDecoderPath('https://cdn.jsdelivr.net/npm/three@0.132.2/examples/js/libs/draco/');
  loader.setDRACOLoader(draco);

  loader.load(path, function(gltf) {
    if (loadVersion !== regionalLoadVersion) return;
    var model = gltf.scene;

    // First pass — collect addon groups as arrays of meshes (exactly as QuietCubes)
    model.traverse(function(node) {
      if (!node.isMesh) return;
      if (!/^Addon/i.test(node.name)) return;
      if (node.name.toLowerCase().includes('arm_screen')) return; // exclude monitor arms
      var groupName = node.name.split('_')[0]; // e.g. "Addon1", "Addon2"
      if (!addonParents[groupName]) addonParents[groupName] = [];
      addonParents[groupName].push(node);
    });

    // Debug: log all mesh names
    var meshNames = [];
    model.traverse(function(node) { if (node.isMesh) meshNames.push(node.name); });
    console.log('[FocusPod] Mesh names in', modelKey + ':\n' + meshNames.join('\n'));

    // Match the CAD-based photography: one pull-handle assembly and one exterior finish.
    const appearance = CAD_APPEARANCE[modelKey];
    if (window.FocusPodReplacement && appearance) {
      model.traverse(node => {
        if (!node.isMesh) return;
        if (appearance.levers.includes(node.name)) node.visible = false;
        if (appearance.paintedFrames.includes(node.name)) node.userData.focuspodMaterial = 'exterior';
        if (appearance.ceilingFelt.includes(node.name)) node.userData.focuspodMaterial = 'interior';
        if (appearance.fans.includes(node.name)) {
          node.userData.focuspodMaterial = 'frame';
          node.material = node.material.clone();
          node.material.color.set(0x151719);
        }
        if (appearance.lightHousings.includes(node.name)) {
          node.material = node.material.clone();
          node.material.color.set(0xffffff);
        }
      });
    }

    buildReplacementPanels(model, modelKey);

    // Second pass — set up materials
    model.traverse(function(node) {
      if (!node.isMesh) return;

      meshMap.set(node.name, node);
      node.castShadow    = true;
      node.receiveShadow = true;

      const replacementMaterial = node.userData.focuspodMaterial;
      if (window.FocusPodReplacement && replacementMaterial) {
        const mat = node.material.clone();
        node.material = mat;
        if (replacementMaterial === 'exterior') exteriorMats.push(mat);
        if (replacementMaterial === 'light') { mat.color.set(0xffffff); mat.emissive.set(0xfffdf5); mat.emissiveIntensity = 0.75; }
        if (replacementMaterial === 'interior') { mat.color.copy(new THREE.Color(currentInteriorHex).convertSRGBToLinear()); interiorMats.push(mat); }
        if (replacementMaterial === 'seat') { mat.color.copy(new THREE.Color(currentSeatHex).convertSRGBToLinear()); seatMats.push(mat); }
        if (replacementMaterial === 'glass') {
          mat.transparent = true; mat.opacity = 0.08; mat.depthWrite = false;
          preparePrivacyMaterial(mat); glassMats.push(mat); glassNodes.push(node);
        }
        return;
      }
      var nl = (node.name || '').toLowerCase();
      if (nl.includes('ventel') || nl.includes('vventel') || nl.includes('ventilation')) ventilationNodes.push(node);

      // --- Hide monitor arms ---
      if (nl.includes('arm_screen_holder')) {
        node.visible = false;
        return;
      }

      // --- Aircon: hide by default ---
      if (node.name === 'Exterior_Air_conditioner' ||
          node.name === 'Exterior_Air_conditioner.001' ||
          node.name === 'Exterior_Air_conditioner.002') {
        airconNode = node; airconNodes.push(node);
        node.visible = false;
        return;
      }

      // --- Glass ---
      if (/^(?:steklo(?:_[rl])?|(?:interior_|exterior_)?glass(?:[._]?\d+|_blur)?)$/i.test(node.name)) {
        node.geometry.computeVertexNormals();
        node.material = new THREE.MeshStandardMaterial({
          color: 0xffffff,
          transparent: true,
          opacity: 0,
          roughness: 0.0,
          metalness: 0.0,
          side: THREE.DoubleSide
        });
        preparePrivacyMaterial(node.material);
        glassMats.push(node.material);
        glassNodes.push(node);
        return;
      }

      // --- Ramka ---
      if (nl.includes('ramka')) {
        node.geometry.computeVertexNormals();
        node.material = new THREE.MeshStandardMaterial({
          color: 0x000000,
          metalness: 0.8,
          roughness: 0.3,
          envMapIntensity: 0.3,
        });
        return;
      }

      // --- Exterior shell ---
      if (node.name === 'Korpus' || node.name === 'EXTERIOR' ||
          node.name === 'Exterior_EXTERIOR' || node.name === 'MAIN' ||
          node.name === 'Exterior_rwhite' || nl.includes('fw001')) {
        node.geometry.computeVertexNormals();
        node.material = new THREE.MeshStandardMaterial({
          metalness: 0.3,
          roughness: 0.2,
        });
        exteriorMats.push(node.material);
        return;
      }

      // --- Always-black: handles, vents ---
      if (nl.includes('ruchka') || nl.includes('ruckka') ||
          nl.includes('ventel') || nl.includes('vventel')) {
        node.material = new THREE.MeshStandardMaterial({
          color: 0x111111, metalness: 0.4, roughness: 0.3
        });
        return;
      }

      // --- Interior ---
      if (node.name === 'INTERIOR' || node.name === 'CURTAINS' ||
          (node.material && (node.material.name.startsWith('INTERIOR') || node.material.name.startsWith('Interior')))) {
        node.material.color.copy(new THREE.Color(currentInteriorHex).convertSRGBToLinear());
        node.material.map = null;
        node.material.needsUpdate = true;
        interiorMats.push(node.material);
        return;
      }

      // --- Legs / chair bases ---
      if (nl.includes('nojka') || nl.includes('nojki')) {
        node.material = new THREE.MeshStandardMaterial({ color: 0x111111, metalness: 0.7, roughness: 0.2 });
        return;
      }

      // --- Table tops ---
      if ((nl.includes('_stol') || nl.includes('table')) &&
          !nl.includes('nojka') && !nl.includes('nojki')) {
        node.material = new THREE.MeshStandardMaterial({ color: 0xf0f0ee, roughness: 0.3, metalness: 0.1 });
        return;
      }

      // NOTE: seats render with GLB material on load.
      // They get fabric texture + colour applied when applyInteriorColor() is called.
    });

    // All current pod assets face +Z. Classify physical panels, independent of exporter names.
    model.updateMatrixWorld(true);
    const panels=glassNodes.filter(node=>!['left','right'].includes(node.userData.focuspodPanel)).map(node=>({node,z:new THREE.Box3().setFromObject(node).getCenter(new THREE.Vector3()).z}));
    const frontZ=Math.max(...panels.map(p=>p.z)),rearZ=Math.min(...panels.map(p=>p.z));
    const middleZ=(frontZ+rearZ)/2;
    panels.forEach(panel=>{(panel.z>=middleZ?glassFrontMats:glassRearMats).push(panel.node.material);});

    // Apply exterior colour
    var extCol = new THREE.Color(currentExteriorHex).convertSRGBToLinear();
    exteriorMats.forEach(function(m) {
      m.color.copy(extCol);
      m.needsUpdate = true;
    });

    applyAtomImageAppearance(model, modelKey);
    addFocusPodSticker(model, modelKey);

    // Camera fit
    var box    = new THREE.Box3().setFromObject(model);
    var center = box.getCenter(new THREE.Vector3());
    var size   = box.getSize(new THREE.Vector3());
    model.position.y -= box.min.y;
    scene.add(model);
    currentModel = model;
    createViewerContactShadow();

    var keys = Object.keys(addonParents).sort();
    keys.forEach(function(k) { (addonParents[k] || []).forEach(function(n) { n.visible = (k === 'Addon1'); }); });
    currentAddonKey = keys.indexOf('Addon1') >= 0 ? 'Addon1' : (keys[0] || '');

    var sphere = new THREE.Sphere();
    box.getBoundingSphere(sphere);
    var fov  = camera.fov * Math.PI / 180;
    var dist = (sphere.radius / Math.tan(fov / 2)) * 1.25;
    camera.position.set(center.x, 1.5, center.z + dist);
    controls.target.set(center.x, size.y / 2, center.z);
    controls.maxDistance = dist * 3;
    controls.update();
    if (document.body.dataset.fpMarket === 'AU') setStudioView(document.querySelector('.us-configurator')?.dataset.activeStep || 'exterior');

    updateAddonUI();
    showLoading(false);
    viewerTourReady = true;
    if (document.body.dataset.fpMarket === 'AU') emitTourState();
    window.dispatchEvent(new CustomEvent('fp:viewer-ready', { detail: { model: modelKey } }));

  }, undefined, function(err) {
    if (loadVersion !== regionalLoadVersion) return;
    viewerTourReady = false;
    stopTour({ restore: false, reason: 'error' });
    if (document.body.dataset.fpMarket === 'AU') emitTourState();
    window.dispatchEvent(new CustomEvent('fp:viewer-error', { detail: { model: modelKey } }));
    showLoading(false);
  });
}

function applyExteriorColor(hex) {
  currentExteriorHex = hex;
  var col = new THREE.Color(hex).convertSRGBToLinear();
  exteriorMats.forEach(function(m) {
    m.color.copy(col);
    m.map = null;
    m.needsUpdate = true;
  });
  meshMap.forEach(function(mesh, meshName) {
    var nl = meshName.toLowerCase();
    if (nl.includes('fw001') || nl.includes('conditio')) {
      mesh.material.color.copy(col);
      mesh.material.map = null;
      mesh.material.needsUpdate = true;
    }
  });
}

function applyInteriorColor(hex) {
  currentInteriorHex = hex;
  var threeColor = new THREE.Color(hex).convertSRGBToLinear();

  interiorMats.forEach(function(m) {
    m.color.copy(threeColor);
    m.map = null;
    m.needsUpdate = true;
  });

  meshMap.forEach(function(mesh, meshName) {
    var nl = meshName.toLowerCase();
    var isExplicit = (
      meshName === 'Addon1_meeting_chair__' ||
      meshName === 'Addon2_Pneumatic_adjustable_stool_remesh' ||
      meshName === 'Addon3_Swivel_armchair' ||
      meshName === 'Addon1_Pneumatic_adjustable_stool' ||
      meshName === 'Addon2_Pneumatic_adjustable_stool' ||
      meshName === 'Addon4_meeting_chair' ||
      meshName === 'Addon2_ramka_wall'
    );
    var isFramePart = nl.includes('frame') || nl.includes('base') || nl.includes('shell') ||
                      nl.includes('back') || nl.includes('nojka') || nl.includes('nojki') ||
                      nl.includes('leg') || nl.includes('metal') || nl.includes('plastic');
    var isFabric = mesh.userData.focuspodMaterial === 'seat' || !isFramePart && (
      nl.includes('seat') || nl.includes('cushion') || nl.includes('couch') ||
      nl.includes('fabric') || nl.includes('upholst') || nl.includes('armchair')
    );
    if (isExplicit || isFabric) {
      mesh.material.map = seatTexture;
      mesh.material.color.copy(threeColor);
      mesh.material.roughness = 1;
      mesh.material.metalness = 0;
      mesh.material.needsUpdate = true;
      if (seatMats.indexOf(mesh.material) === -1) {
        seatMats.push(mesh.material);
      }
    }
  });
}

function applySeatColor(hex) {
  currentSeatHex = hex;
  var col = new THREE.Color(hex).convertSRGBToLinear();
  seatMats.forEach(function(m) {
    m.color.copy(col);
    m.needsUpdate = true;
  });
}

function applyFabricTexture(url) {
  var tex = textureLoader.load(url, function(t) {
    t.wrapS = t.wrapT = THREE.RepeatWrapping;
    t.repeat.set(4, 4);
    t.encoding = THREE.sRGBEncoding;
    seatMats.forEach(function(m) { m.map = t; m.needsUpdate = true; });
  });
}

let privacySelection = {type:'clear', sides:'front', coverage:'full'};
let privacyPreviewOpaque = true;

function preparePrivacyMaterial(material) {
  const uniforms = {fpPrivacyMin:{value:-1e6},fpPrivacyMax:{value:1e6}};
  material.userData.privacyUniforms = uniforms;
  material.depthWrite = false;
  material.onBeforeCompile = shader => {
    Object.assign(shader.uniforms, uniforms);
    shader.vertexShader = 'varying float vFpPrivacyY;\n' + shader.vertexShader;
    shader.vertexShader = shader.vertexShader.replace('#include <begin_vertex>', '#include <begin_vertex>\nvFpPrivacyY = (modelMatrix * vec4(position, 1.0)).y;');
    shader.fragmentShader = 'varying float vFpPrivacyY;\nuniform float fpPrivacyMin;\nuniform float fpPrivacyMax;\n' + shader.fragmentShader;
    shader.fragmentShader = shader.fragmentShader.replace('#include <alphatest_fragment>', 'if (vFpPrivacyY < fpPrivacyMin || vFpPrivacyY > fpPrivacyMax) discard;\n#include <alphatest_fragment>');
  };
  material.customProgramCacheKey = () => 'focuspod-privacy-coverage-v1';
}

function setPrivacy(selection) {
  privacySelection = selection || {type:'clear',sides:'front',coverage:'full'};
  const version = ++pdlcVersion, front = new Set(glassFrontMats);
  const bounds = glassNodes.map(node=>new THREE.Box3().setFromObject(node));
  const minY = Math.min(...bounds.map(b=>b.min.y)), maxY = Math.max(...bounds.map(b=>b.max.y));
  const h = maxY-minY;
  const band = privacySelection.type==='frosted' ? privacySelection.coverage : 'full';
  const low = band==='band' ? minY+h*.25 : minY-0.01;
  const high = band==='half' ? minY+h*.5 : band==='band' ? minY+h*.75 : maxY+0.01;
  const active = privacySelection.type==='frosted' || (privacySelection.type==='pdlc' && privacyPreviewOpaque);
  const transitions=glassMats.map(material=>{
    const uniforms=material.userData.privacyUniforms;
    if(uniforms){uniforms.fpPrivacyMin.value=low;uniforms.fpPrivacyMax.value=high;}
    const selected=front.has(material)||(privacySelection.sides==='both'&&(!window.FocusPodReplacement||glassRearMats.includes(material))); 
    material.roughness=active&&selected ? .9 : 0;
    return {material,from:material.opacity,to:active&&selected ? .94 : (window.FocusPodReplacement ? .08 : 0)};
  });
  const start=performance.now();
  function tick(now){
    if(version!==pdlcVersion)return;
    const progress=Math.min((now-start)/250,1);
    transitions.forEach(({material,from,to})=>{material.opacity=from+(to-from)*progress;});
    if(progress<1)requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
}

function setPrivacyPreview(opaque) {
  privacyPreviewOpaque=Boolean(opaque);
  setPrivacy(privacySelection);
}

function setPDLC(mode) {
  setPrivacy({type:mode==='front'||mode==='both'?'pdlc':'clear',sides:mode||'front',coverage:'full'});
}

function setAircon(enabled) {
  airconNodes.forEach(function(node) { node.visible = Boolean(enabled); });
  var replacesVentilation = enabled && !['meet', 'max'].includes(climateModelKey);
  ventilationNodes.forEach(function(node) { node.visible = !replacesVentilation; });
}

function screenshot() {
  var canvas = document.getElementById('viewer');
  if (!canvas) return;
  var link = document.createElement('a');
  link.download = 'focuspod-config.png';
  link.href = canvas.toDataURL('image/png');
  link.click();
}

function getAddonKeys() { return Object.keys(addonParents).sort(); }

// Small reference images use the original furniture meshes in a separate scene.
// No model visibility, materials, selection, controls or live camera are changed.
const furnitureThumbnailCache = new Map();
function renderFurnitureThumbnail(key) {
  if (document.body.dataset.fpMarket !== 'AU' || document.hidden || viewerTour || !viewerTourReady || !currentModel || !renderer) return null;
  const nodes = (addonParents[key] || []).filter(node => node.isMesh && node.geometry);
  if (!nodes.length) return null;
  const cacheKey = MODEL_FILES[climateModelKey] + '|' + climateModelKey + '|' + key;
  if (furnitureThumbnailCache.has(cacheKey)) return furnitureThumbnailCache.get(cacheKey);
  const width = 480, height = 300, resources = [];
  let target = null, saved = null;
  try {
    currentModel.updateMatrixWorld(true);
    const thumbnailScene = new THREE.Scene(), group = new THREE.Group();
    thumbnailScene.background = new THREE.Color('#e9e6e0');
    thumbnailScene.environment = scene.environment;
    nodes.forEach(node => {
      const clone = node.clone(false);
      clone.matrixAutoUpdate = false; clone.matrix.copy(node.matrixWorld);
      clone.visible = true; clone.castShadow = false; clone.receiveShadow = false;
      group.add(clone);
    });
    thumbnailScene.add(group); group.updateMatrixWorld(true);
    const box = new THREE.Box3().setFromObject(group);
    if (box.isEmpty()) return null;
    const size = box.getSize(new THREE.Vector3()), center = box.getCenter(new THREE.Vector3());
    if (![...size.toArray(), ...center.toArray()].every(Number.isFinite) || size.length() < .001) return null;
    scene.children.filter(node => node.isLight).forEach(light => {
      const clone = light.clone(); clone.castShadow = false; thumbnailScene.add(clone);
    });
    thumbnailScene.add(new THREE.HemisphereLight(0xffffff, 0xc3b9a8, .55));
    const thumbnailCamera = new THREE.OrthographicCamera(-1, 1, 1, -1, .01, 100);
    thumbnailCamera.position.copy(center).add(new THREE.Vector3(.78, .58, 1).normalize().multiplyScalar(Math.max(4, size.length() * 3)));
    thumbnailCamera.lookAt(center); thumbnailCamera.updateMatrixWorld(true);
    let halfWidth = 0, halfHeight = 0;
    const corner = new THREE.Vector3();
    for (const x of [box.min.x, box.max.x]) for (const y of [box.min.y, box.max.y]) for (const z of [box.min.z, box.max.z]) {
      corner.set(x, y, z).applyMatrix4(thumbnailCamera.matrixWorldInverse);
      halfWidth = Math.max(halfWidth, Math.abs(corner.x)); halfHeight = Math.max(halfHeight, Math.abs(corner.y));
    }
    const vertical = Math.max(halfHeight, halfWidth / (width / height)) * 1.14;
    thumbnailCamera.left = -vertical * width / height; thumbnailCamera.right = -thumbnailCamera.left;
    thumbnailCamera.top = vertical; thumbnailCamera.bottom = -vertical; thumbnailCamera.updateProjectionMatrix();
    // A subtle floor shadow grounds the isolated layout without changing its geometry.
    const shadowCanvas = document.createElement('canvas'); shadowCanvas.width = shadowCanvas.height = 64;
    const shadowContext = shadowCanvas.getContext('2d');
    if (shadowContext) {
      const gradient = shadowContext.createRadialGradient(32,32,4,32,32,32);
      gradient.addColorStop(0,'rgba(49,45,38,.22)'); gradient.addColorStop(1,'rgba(49,45,38,0)');
      shadowContext.fillStyle = gradient; shadowContext.fillRect(0,0,64,64);
      const texture = new THREE.CanvasTexture(shadowCanvas), geometry = new THREE.PlaneGeometry(Math.max(.25,size.x * 1.25),Math.max(.25,size.z * 1.25));
      const material = new THREE.MeshBasicMaterial({map:texture,transparent:true,depthWrite:false,toneMapped:false});
      resources.push(texture, geometry, material);
      const shadow = new THREE.Mesh(geometry,material); shadow.rotation.x = -Math.PI / 2; shadow.position.set(center.x,box.min.y-.003,center.z); thumbnailScene.add(shadow);
    }
    target = new THREE.WebGLRenderTarget(width,height,{depthBuffer:true,stencilBuffer:false});
    target.texture.encoding = renderer.outputEncoding; target.texture.generateMipmaps = false;
    saved = {target:renderer.getRenderTarget(),cube:renderer.getActiveCubeFace(),mip:renderer.getActiveMipmapLevel(),viewport:renderer.getViewport(new THREE.Vector4()),scissor:renderer.getScissor(new THREE.Vector4()),scissorTest:renderer.getScissorTest(),color:renderer.getClearColor(new THREE.Color()),alpha:renderer.getClearAlpha(),autoClear:renderer.autoClear,xr:renderer.xr.enabled,shadow:renderer.shadowMap.enabled};
    renderer.xr.enabled = false; renderer.shadowMap.enabled = false; renderer.autoClear = true;
    renderer.setRenderTarget(target); renderer.setScissorTest(false); renderer.render(thumbnailScene,thumbnailCamera);
    const pixels = new Uint8Array(width * height * 4); renderer.readRenderTargetPixels(target,0,0,width,height,pixels);
    const canvas = document.createElement('canvas'); canvas.width = width; canvas.height = height;
    const context = canvas.getContext('2d'); if (!context) return null;
    const image = context.createImageData(width,height), stride = width * 4;
    for (let row = 0; row < height; row++) image.data.set(pixels.subarray((height-row-1)*stride,(height-row)*stride),row*stride);
    context.putImageData(image,0,0);
    const url = canvas.toDataURL('image/png'); furnitureThumbnailCache.set(cacheKey,url); return url;
  } catch (error) {
    console.warn('[FocusPod] Furniture image unavailable:', key);
    return null;
  } finally {
    if (saved) {
      renderer.xr.enabled = saved.xr; renderer.shadowMap.enabled = saved.shadow; renderer.autoClear = saved.autoClear;
      renderer.setClearColor(saved.color,saved.alpha); renderer.setViewport(saved.viewport); renderer.setScissor(saved.scissor); renderer.setScissorTest(saved.scissorTest);
      renderer.setRenderTarget(saved.target,saved.cube,saved.mip);
    }
    if (target) target.dispose(); resources.forEach(resource => resource.dispose());
  }
}

function selectAddon(key) {
  Object.keys(addonParents).forEach(function(k) { (addonParents[k] || []).forEach(function(n) { n.visible = (k === key); }); });
  currentAddonKey = key;
}

function hideAllAddons() {
  Object.keys(addonParents).forEach(function(k) { (addonParents[k] || []).forEach(function(n) { n.visible = false; }); });
  currentAddonKey = '__none__';
}

function cycleAddon(dir) {
  var keys = getAddonKeys();
  if (!keys.length) return;
  var idx = ((keys.indexOf(currentAddonKey) + dir) % keys.length + keys.length) % keys.length;
  selectAddon(keys[idx]);
}

function updateAddonUI() {
  if (window.onAddonGroupsChanged) window.onAddonGroupsChanged(getAddonKeys(), currentAddonKey);
}

function showLoading(show) {}

let studioCameraView = 'exterior';
function setStudioView(view, preserveAngle = false) {
  stopTour({ restore: false, reason: 'view' });
  if (!currentModel || !camera || !controls) return;
  studioCameraView = ['exterior','interior','furniture','privacy-front','privacy-rear'].includes(view) ? view : 'exterior';
  const box = new THREE.Box3().setFromObject(currentModel);
  const center = box.getCenter(new THREE.Vector3());
  const sphere = box.getBoundingSphere(new THREE.Sphere());
  const halfVertical = camera.fov * Math.PI / 360;
  const halfHorizontal = Math.atan(Math.tan(halfVertical) * camera.aspect);
  const distance = sphere.radius / Math.sin(Math.min(halfVertical, halfHorizontal)) * 1.06;
  const offset = preserveAngle ? camera.position.clone().sub(controls.target) : (studioCameraView === 'privacy-rear' ? new THREE.Vector3(-.35,.12,-1) : studioCameraView === 'privacy-front' ? new THREE.Vector3(.25,.12,1) : studioCameraView === 'exterior' ? new THREE.Vector3(.6, .16, 1) : new THREE.Vector3(studioCameraView === 'furniture' ? .08 : 0, .04, 1));
  offset.normalize().multiplyScalar(distance);
  controls.target.copy(center);
  camera.position.copy(center).add(offset);
  controls.maxDistance = distance * 3;
  controls.update();
}

function resetCamera() {
  stopTour({ restore: false, reason: 'reset' });
  if (!currentModel) return;
  if (document.body.dataset.fpMarket === 'AU') { setStudioView(studioCameraView); return; }
  var box    = new THREE.Box3().setFromObject(currentModel);
  var center = box.getCenter(new THREE.Vector3());
  var size   = box.getSize(new THREE.Vector3());
  var sphere = new THREE.Sphere();
  box.getBoundingSphere(sphere);
  var fov  = camera.fov * Math.PI / 180;
  var dist = (sphere.radius / Math.tan(fov / 2)) * 1.25;
  camera.position.set(center.x, 1.5, center.z + dist);
  controls.target.set(center.x, size.y / 2, center.z);
  controls.update();
}

function zoomBy(factor) {
  stopTour({ restore: false, reason: 'zoom' });
  if(!camera || !controls || !currentModel || !Number.isFinite(factor) || factor<=0)return;
  const sphere=new THREE.Box3().setFromObject(currentModel).getBoundingSphere(new THREE.Sphere());
  const offset=camera.position.clone().sub(controls.target);
  const distance=Math.max(sphere.radius*.65,Math.min(controls.maxDistance,offset.length()*factor));
  offset.setLength(distance);camera.position.copy(controls.target).add(offset);controls.update();
}

function captureConfigurationImage(expectedModel, view='three-quarter') {
  if(viewerTour)stopTour({restore:true,reason:'saved-design'});
  if (!currentModel || !renderer || !scene || !viewerTourReady || climateModelKey!==expectedModel) return null;
  let target, saved;
  try {
    currentModel.updateMatrixWorld(true);
    const box = new THREE.Box3();
    currentModel.traverse(node=>{
      if(!node.isMesh||!node.geometry)return;
      let visible=true;for(let p=node;p&&p!==currentModel.parent;p=p.parent)if(!p.visible)visible=false;
      if(!visible)return;
      if(!node.geometry.boundingBox)node.geometry.computeBoundingBox();
      if(node.geometry.boundingBox)box.union(node.geometry.boundingBox.clone().applyMatrix4(node.matrixWorld));
    });
    if(box.isEmpty())return null;
    // Square, high-density export keeps the pod prominent on mobile and sharp on desktop.
    const width=2400,height=2400,size=box.getSize(new THREE.Vector3()),center=box.getCenter(new THREE.Vector3());
    const exportCamera=new THREE.OrthographicCamera(-1,1,1,-1,.01,1000);
    exportCamera.position.copy(center).add(new THREE.Vector3(view==='front'?.08:.8,view==='front'?.12:.34,1.5).normalize().multiplyScalar(Math.max(10,size.length()*4)));
    exportCamera.lookAt(center);exportCamera.updateMatrixWorld(true);
    let halfWidth=0,halfHeight=0;const corner=new THREE.Vector3();
    for(const x of [box.min.x,box.max.x])for(const y of [box.min.y,box.max.y])for(const z of [box.min.z,box.max.z]){
      corner.set(x,y,z).applyMatrix4(exportCamera.matrixWorldInverse);halfWidth=Math.max(halfWidth,Math.abs(corner.x));halfHeight=Math.max(halfHeight,Math.abs(corner.y));
    }
    const vertical=Math.max(halfHeight,halfWidth/(width/height))*1.04;
    exportCamera.left=-vertical*width/height;exportCamera.right=-exportCamera.left;exportCamera.top=vertical;exportCamera.bottom=-vertical;exportCamera.updateProjectionMatrix();
    target=new THREE.WebGLRenderTarget(width,height,{depthBuffer:true,stencilBuffer:false});target.texture.encoding=renderer.outputEncoding;target.texture.generateMipmaps=false;
    saved={background:scene.background,target:renderer.getRenderTarget(),cube:renderer.getActiveCubeFace(),mip:renderer.getActiveMipmapLevel(),viewport:renderer.getViewport(new THREE.Vector4()),scissor:renderer.getScissor(new THREE.Vector4()),scissorTest:renderer.getScissorTest(),xr:renderer.xr.enabled,auto:renderer.autoClear};
    scene.background=new THREE.Color('#f3f5f7');renderer.xr.enabled=false;renderer.autoClear=true;renderer.setRenderTarget(target);renderer.setScissorTest(false);renderer.render(scene,exportCamera);
    const pixels=new Uint8Array(width*height*4);renderer.readRenderTargetPixels(target,0,0,width,height,pixels);
    const canvas=document.createElement('canvas');canvas.width=width;canvas.height=height;const context=canvas.getContext('2d');if(!context)return null;
    const image=context.createImageData(width,height),stride=width*4;
    for(let row=0;row<height;row++)image.data.set(pixels.subarray((height-row-1)*stride,(height-row)*stride),row*stride);
    context.putImageData(image,0,0);
    // Keep sharp source pixels within the delivery service's 800 KB image limit.
    for(const quality of [.96,.93,.90,.87]){const result=canvas.toDataURL('image/jpeg',quality);if((result.length-result.indexOf(',')-1)*.75<=790000)return result;}
    return null;
  }catch{return null;}finally{
    if(saved){scene.background=saved.background;renderer.xr.enabled=saved.xr;renderer.autoClear=saved.auto;renderer.setRenderTarget(saved.target,saved.cube,saved.mip);renderer.setViewport(saved.viewport);renderer.setScissor(saved.scissor);renderer.setScissorTest(saved.scissorTest);}
    target?.dispose();
  }
}

window.FocusPodViewer = { captureConfigurationImage, zoomBy, setStudioView, startTour, pauseTour, resumeTour, stopTour, tourGo, tourStatus, tourAnchor, setTourReducedMotion, renderFurnitureThumbnail,
  initViewer, loadModel, setPanels,
  applyExteriorColor, applyInteriorColor, applySeatColor, applyFabricTexture,
  setPDLC, setPrivacy, setPrivacyPreview, setAircon, screenshot, resetCamera,
  selectAddon, hideAllAddons, cycleAddon, getAddonKeys,
};

